import BusinessEntry, { BusinessRetrievalError, BusinessSingpassButton } from "../myinfo-business/BusinessEntry";
import BusinessDataReview, { businessSections } from "../myinfo-business/BusinessDataReview";
import { getPersonData, getMyInfoData } from "../../utils/myinfoData";
import { startNetrustTrial, isNetrustTrialEntry, netrustTrialResolveRequest, hasNetrustTrialContext, isNetrustTrialCallback } from "./netrustTrial";
import "./AuthenticationReview.css";
// import React from "react";
// import { useState, useEffect } from "react";
// import Cookies from "js-cookie";
// import { Box, useTheme } from "@mui/material";
// import adspot_ico from "../../../src/assets/img/businessman-receiving-money-after-contract-signing.png";
// import { Typography, notification, Upload } from "antd";
// import { tokens } from "../../../src/theme";
// import { Progress, Button, message, Avatar, Modal } from "antd";
// import {
//   UserOutlined,
//   UploadOutlined,
//   QuestionOutlined,
// } from "@ant-design/icons";

import {
  Card,
  Tabs,
  Button,
  Modal,
  message,
  Spin,
  Form,
  Input,
  Select,
  Col,
  Row,
  DatePicker,
  Space,
  notification,
  Table,
} from "antd";
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import adspot_ico from "../../assets/img/businessman-receiving-money-after-contract-signing.png";
import { useHistory } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import singlogo from "../../pages/smart-lend-frontend/src/img/singpass_logo.png";
import { useLocation } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import ErrorIcon from "@mui/icons-material/Error";
import moment from "moment";
import { format } from "date-fns";
import myinfoLogo from "../../../src/pages/smart-lend-frontend/src/img/myinfo_logo_2.png";

const BRAND = "var(--br-primary, rgb(14, 90, 165))";
const BRAND2 = "rgb(109, 92, 246)"; // accent similar to wizard
const BasicInformation = (props) => {
  const { Option } = Select;
  const [nric, setNric] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [principalname, setPrincipalName] = useState("");
  const [gender, setGender] = useState("");
  const [race, setRace] = useState("");
  const [residentialstatus, setResidentialStatus] = useState("");
  const [nationality, setNationality] = useState("");
  const [countryofbirth, setCountryOfBirth] = useState("");
  const [employmentsector, setEmploymentSector] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [registeredaddress, setRegisteredAddress] = useState("");
  const [data, setData] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const [errorMessage, setErrorMessage] = useState("");
  const [nric2, setNric2] = useState("");
  const [passType, setPassType] = useState("");
  const [passStatus, setPassStatus] = useState("");
  const [passExpiryDate, setPassExpiryDate] = useState("");
  const [typeOfHDB, setTypeOfHDB] = useState("");
  const [typeOfHousing, setTypeOfHousing] = useState("");
  const [ownerprivateresidentialproperty, setOwnerPrivateResidentialProperty] =
    useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [occupation, setOccupation] = useState("");
  const [cpfOrdinaryAccount, setCpfOrdinaryAccount] = useState("");
  const [cpfSpecialAccount, setCpfSpecialAccount] = useState("");
  const [cpfMedisaveAccount, setCpfMedisaveAccount] = useState("");
  const [cpfRetirementAccount, setCpfRetirementAccount] = useState("");
  const [employmentCompany, setEmploymentCompany] = useState("");
  const [latestCpfContribution, setLatestCpfContribution] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [latestNoaYear, setLatestNoaYear] = useState("");
  const [latestNoaAmount, setLatestNoaAmount] = useState("");

  const parseMaybeJson = (value) => {
    if (!value) return null;
    if (typeof value === "object") return value;

    try {
      return JSON.parse(value);
    } catch (error) {
      console.error("Failed to parse JSON payload", error);
      return null;
    }
  };

  const pickFirst = (...values) =>
    values.find((value) => value !== null && value !== undefined && value !== "");

  const formatAddress = (address) => {
    if (!address) return "";
    return (
      (address?.unit?.value !== null && address?.unit?.value !== undefined
        ? `Unit ${address?.unit?.value}, `
        : "") +
      (address?.floor?.value !== null && address?.floor?.value !== undefined
        ? `Floor ${address?.floor?.value}, `
        : "") +
      (address?.block?.value !== null && address?.block?.value !== undefined
        ? `Block ${address?.block?.value}, `
        : "") +
      (address?.street?.value !== null && address?.street?.value !== undefined
        ? `${address?.street?.value}, `
        : "") +
      (address?.postal?.value !== null && address?.postal?.value !== undefined
        ? `${address?.postal?.value}, `
        : "") +
      (address?.country?.desc !== null && address?.country?.desc !== undefined
        ? `${address?.country?.desc}.`
        : "")
    );
  };

  const formatCpfValue = (value, unavailable = false) => {
    if (unavailable) return "Unavailable";
    if (value === null || value === undefined || value === "") return "";

    const numberValue = Number(value);
    if (Number.isNaN(numberValue)) return String(value);

    return numberValue.toLocaleString("en-SG", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleUploadProfilePicture = async (file) => {
    console.log("uploading profile picture");
    try {
      const formData = new FormData();
      formData.append("profile_picture", file);
      console.log("uploading", formData);
      const response = await fetch(
        "https://www.smart-lend.com/api/profile/uploadProfilePicture",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: formData,
        }
      );

      const data = await response.json();

      console.log("Profile picture created", data);

      // Update the imageUrl state with the new image URL
      if (data.profile_picture) {
        setImageUrl(data.profile_picture);
        Cookies.setItem("profile_picture", data.profile_picture);
        notification.open({
          message: "Notification Title",
          description:
            "I will never close automatically. This is a purposely very very long description that has many many characters and words.",
          duration: 4,
        });
      } else if (data.error && data.error.profile_picture) {
        // If the profile picture failed to upload
        throw new Error(data.error.profile_picture[0]);
      }
    } catch (error) {
      console.error("Error Uploading Picture", error);
      setErrorMessage(error.message);
    }
  };

  const handleSave = async () => {
    try {
      // Assuming singpassData is an array with only one object
      let updatedSingpassData = { ...props.singpassData };
      if (
        updatedSingpassData.singpass_data &&
        updatedSingpassData.singpass_data.length > 0
      ) {
        updatedSingpassData.singpass_data[0].email = email; // Add email
        updatedSingpassData.singpass_data[0].phone = phone; // Add phone
      }

      let item = {
        singpassData: updatedSingpassData,
      };

      const response = await fetch(
        `https://www.smart-lend.com/api/singpass/updateSingpassData`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify(item),
        }
      );

      const jsonSingpassData = await response.json();
      console.log("jsonSingpassData:", jsonSingpassData);
      if (response.status === 200) {
        message.success("Your Data Successfully Saved");
      } else {
        message.error("Your Data Unable to Save");
      }
    } catch (err) {
      message.error("Your Data Unable to Save");
      console.log("err handleSave:", err);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/singpass/getSingpassData",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const displaySingpassData = await response.json();
        const singpassData = parseMaybeJson(displaySingpassData?.singpass_data);
        const myinfoData = parseMaybeJson(displaySingpassData?.myinfo_data);
        const singpassPersonDetail = getPersonData(singpassData) || {};
        const myinfoPersonDetail = getMyInfoData(myinfoData) || {};

        if (Object.keys(singpassPersonDetail).length || Object.keys(myinfoPersonDetail).length) {
          const mobileData =
            myinfoPersonDetail?.mobileno || singpassPersonDetail?.mobileno || {};
          const fullMobileNumber =
            (mobileData?.prefix?.value || "") +
            (mobileData?.areacode?.value || "") +
            (mobileData?.nbr?.value || "");
          const address = pickFirst(
            myinfoPersonDetail?.regadd,
            singpassPersonDetail?.regadd,
            myinfoPersonDetail?.hdbownership?.[0]?.address,
            singpassPersonDetail?.hdbownership?.[0]?.address
          );

          setNric(
            pickFirst(
              myinfoPersonDetail?.uinfin?.value,
              singpassPersonDetail?.uinfin?.value,
              ""
            )
          );
          setBirthdate(
            pickFirst(
              myinfoPersonDetail?.dob?.value,
              singpassPersonDetail?.dob?.value,
              ""
            )
          );
          setPrincipalName(
            pickFirst(
              myinfoPersonDetail?.name?.value,
              singpassPersonDetail?.name?.value,
              ""
            )
          );
          setGender(
            pickFirst(
              myinfoPersonDetail?.sex?.desc,
              singpassPersonDetail?.sex?.desc,
              ""
            )
          );
          setRace(
            pickFirst(
              myinfoPersonDetail?.race?.desc,
              singpassPersonDetail?.race?.desc,
              ""
            )
          );
          setCountryOfBirth(
            pickFirst(
              myinfoPersonDetail?.birthcountry?.desc,
              singpassPersonDetail?.birthcountry?.desc,
              ""
            )
          );
          setEmploymentSector(
            pickFirst(
              myinfoPersonDetail?.employmentsector?.value,
              singpassPersonDetail?.employmentsector?.value,
              ""
            )
          );
          setEmploymentCompany(
            pickFirst(
              myinfoPersonDetail?.employment?.value,
              singpassPersonDetail?.employment?.value,
              ""
            )
          );
          setOwnerPrivateResidentialProperty(
            pickFirst(
              myinfoPersonDetail?.ownerprivate?.value,
              singpassPersonDetail?.ownerprivate?.value,
              ""
            )
          );
          setResidentialStatus(
            pickFirst(
              myinfoPersonDetail?.residentialstatus?.desc,
              myinfoPersonDetail?.residentialstatus?.value?.desc,
              singpassPersonDetail?.residentialstatus?.desc,
              singpassPersonDetail?.residentialstatus?.value?.desc,
              ""
            )
          );
          setNationality(
            pickFirst(
              myinfoPersonDetail?.nationality?.desc,
              singpassPersonDetail?.nationality?.desc,
              ""
            )
          );
          setEmail(
            pickFirst(
              myinfoPersonDetail?.email?.value,
              singpassPersonDetail?.email?.value,
              ""
            )
          );
          setPhone(
            fullMobileNumber ||
              pickFirst(
                myinfoPersonDetail?.mobileno?.nbr?.value,
                singpassPersonDetail?.mobileno?.nbr?.value,
                ""
              )
          );
          setRegisteredAddress(formatAddress(address));
          setTypeOfHDB(
            pickFirst(
              myinfoPersonDetail?.hdbtype?.desc,
              singpassPersonDetail?.hdbtype?.desc,
              ""
            )
          );
          setTypeOfHousing(
            pickFirst(
              myinfoPersonDetail?.housingtype?.desc,
              myinfoPersonDetail?.housingType?.desc,
              singpassPersonDetail?.housingtype?.desc,
              singpassPersonDetail?.housingType?.desc,
              ""
            )
          );
          setMaritalStatus(
            pickFirst(
              myinfoPersonDetail?.marital?.desc,
              singpassPersonDetail?.marital?.desc,
              ""
            )
          );
          setOccupation(
            pickFirst(
              myinfoPersonDetail?.occupation?.value,
              singpassPersonDetail?.occupation?.value,
              ""
            )
          );
          setPassType(
            pickFirst(
              myinfoPersonDetail?.passtype?.desc,
              singpassPersonDetail?.passtype?.desc,
              ""
            )
          );
          setPassStatus(
            pickFirst(
              myinfoPersonDetail?.passstatus?.value,
              singpassPersonDetail?.passstatus?.value,
              ""
            )
          );
          setPassExpiryDate(
            pickFirst(
              myinfoPersonDetail?.passexpirydate?.value,
              singpassPersonDetail?.passexpirydate?.value,
              ""
            )
          );
          setCpfOrdinaryAccount(
            formatCpfValue(
              pickFirst(
                myinfoPersonDetail?.cpfbalances?.oa?.value,
                singpassPersonDetail?.cpfbalances?.oa?.value,
                ""
              ),
              myinfoPersonDetail?.cpfbalances?.oa?.unavailable ||
                singpassPersonDetail?.cpfbalances?.oa?.unavailable
            )
          );
          setCpfSpecialAccount(
            formatCpfValue(
              pickFirst(
                myinfoPersonDetail?.cpfbalances?.sa?.value,
                singpassPersonDetail?.cpfbalances?.sa?.value,
                ""
              ),
              myinfoPersonDetail?.cpfbalances?.sa?.unavailable ||
                singpassPersonDetail?.cpfbalances?.sa?.unavailable
            )
          );
          setCpfMedisaveAccount(
            formatCpfValue(
              pickFirst(
                myinfoPersonDetail?.cpfbalances?.ma?.value,
                singpassPersonDetail?.cpfbalances?.ma?.value,
                ""
              ),
              myinfoPersonDetail?.cpfbalances?.ma?.unavailable ||
                singpassPersonDetail?.cpfbalances?.ma?.unavailable
            )
          );
          setCpfRetirementAccount(
            formatCpfValue(
              pickFirst(
                myinfoPersonDetail?.cpfbalances?.ra?.value,
                singpassPersonDetail?.cpfbalances?.ra?.value,
                ""
              ),
              myinfoPersonDetail?.cpfbalances?.ra?.unavailable ||
                singpassPersonDetail?.cpfbalances?.ra?.unavailable
            )
          );
          setVehicleType(
            pickFirst(
              myinfoPersonDetail?.vehicles?.[0]?.type?.value,
              singpassPersonDetail?.vehicles?.[0]?.type?.value,
              ""
            )
          );

          const latestCpfContributionRecord =
            myinfoPersonDetail?.cpfcontributions?.history?.[0] ||
            singpassPersonDetail?.cpfcontributions?.history?.[0];
          setLatestCpfContribution(
            formatCpfValue(latestCpfContributionRecord?.amount?.value)
          );

          const latestNoaRecord =
            myinfoPersonDetail?.noahistory?.noas?.[0] ||
            singpassPersonDetail?.noahistory?.noas?.[0];
          setLatestNoaYear(latestNoaRecord?.yearofassessment?.value || "");
          setLatestNoaAmount(formatCpfValue(latestNoaRecord?.amount?.value));
        }
        // console.log("value nric2:", displaySingpassData.singpass_data.person);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  //   useEffect(() => {
  //     setNric(nric2);
  //  }, [nric2]);

  function handleNricChange(e) {
    setNric(e.target.value);
  }

  useEffect(() => {
    async function fetchData() {
      const profilePictureUrl =
        (await loadprofilepicture()) || Cookies.get("profile_picture");
      if (profilePictureUrl) {
        setImageUrl(profilePictureUrl);
      }
    }
    fetchData();
  }, []);

  // useEffect(() => {
  //     async function fetchData() {
  //         const headers = new Headers();
  //         headers.append("Content-Type", "application/json");
  //         headers.append("Authorization", "Bearer " + Cookies.get('token'));

  //         const options = {
  //             method: 'GET',
  //             headers: headers,
  //         };

  //         try {
  //             const response = await fetch(
  //                 "https://www.smart-lend.com/api/profile/viewPersonal?type=Basic",
  //                 options
  //             );

  //             if (!response.ok) {
  //                 throw new Error("Failed to fetch data");
  //             }

  //             const data = await response.json();

  //             setData(data["Basic Data"]);
  //             // Set state variables when data is fetched
  //             if (data["Basic Data"] && data["Basic Data"][0]) {
  //                 const item = data["Basic Data"][0];
  //                 console.log("data item", item);
  //                 setNric(item.nric.toString()); // Convert NRIC to string
  //                 setBirthdate(item.date_of_birth);
  //                 setGender(item.sex);
  //                 setRace(item.race);
  //                 setResidentialStatus(item.residential_status);
  //                 setNationality(item.nationality);
  //                 setCountryOfBirth(item.country_of_birth);
  //                 setEmploymentSector(item.employment_sector);
  //                 setEmail(item.email);
  //                 setPhone(item.mobile_no);
  //                 setRegisteredAddress(item.registered_address);
  //             }
  //         } catch (error) {
  //             console.error(error);
  //         }

  //         const profilePictureUrl = Cookies.get('profile_picture') || await loadprofilepicture();
  //         if (profilePictureUrl) {
  //             setImageUrl(profilePictureUrl);
  //         }
  //     }
  //     fetchData();
  // }, []);

  const [imageUrl, setImageUrl] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleBeforeUpload = (file) => {
    const imageUrl = URL.createObjectURL(file);
    setImageUrl(imageUrl);
    console.log("Photo ready to upload", file);
    setSelectedFile(file);
    return false; // Prevent file from being uploaded automatically
  };

  const handleConfirm = () => {
    if (selectedFile) {
      handleUploadProfilePicture(selectedFile);
      console.log("selectedFile exists", selectedFile);
      setSelectedFile(null); // Reset the selected file after uploading
    }
  };

  const loadprofilepicture = async () => {
    console.log("getting profile picture");
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/profile/viewInfoProfilePicture",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch profile picture");
      }

      const blob = await response.blob();
      const imageUrl = URL.createObjectURL(blob);
      console.log("Profile picture retrieved", imageUrl);
      return imageUrl;
    } catch (error) {
      console.error("Error retrieving profile picture", error);
      return null;
    }
  };

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
    vertical: true,
  };

  const tailLayout = {
    wrapperCol: {
      offset: 0,
      span: 24,
    },
  };

  const onFinish = (values) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const [screenWidth, setScreenWidth] = useState(1920);
  const [isMobile, setIsMobile] = useState(
    Cookies.get("ismobile") === "yes" ? true : false
  );
  useEffect(() => {
    if (screenWidth < 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Form
      style={{ minHeight: "73vh" }}
      {...layout}
      name="basic"
      initialValues={
        {
          // nric: nric2,
          // birthdate: birthdate ? moment(birthdate, "YYYY-MM-DD") : null,
          // gender: "Male",
          // race: race,
          // residentialstatus: residentialstatus,
          // nationality: nationality,
          // countryofbirth: countryofbirth,
          // employmentsector: employmentsector,
          // email: email,
          // phone: phone,
          // registeredaddress: registeredaddress,
          // remember: true,
        }
      }
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col
          span={isMobile ? 24 : 12}
          style={{
            display: "flex",
            justifyContent: "left",
            alignItems: "left",
          }}
        >
          {/* <div> */}
          {/* <Form.Item label="Profile Picture" name="profile"></Form.Item>
                <Upload
                  beforeUpload={handleBeforeUpload}
                  showUploadList={false}
                  fileList={selectedFile ? [selectedFile] : []}
                >
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      // alt="Profile picture"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50px",
                        objectFit: "cover",
                        // marginTop:"-3vh",
                        // marginBottom:"0.5vh"
                      }}
                    />
                  ) : (
                    <Avatar size={64} icon={<UserOutlined />} />
                  )}
                </Upload> */}
          <br />
          {/* {errorMessage && (
                  <div className="error-message">{errorMessage}</div>
                )}
                <div
                  className="all_button"
                  onClick={handleConfirm}
                  style={{
                    background: "#0a58ca",
                    cursor: "pointer",
                    padding: "8px 25px",
                    borderRadius: "10px",
                    textAlign: "center",
                    width: "100%",
                    marginTop: "10px",
                    color: "white",
                  }}
                >
                  Confirm
                </div>
              </div> */}
        </Col>
      </Row>
      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item
            label="NRIC"
            // rules={[{ required: true, message: "Please input your NRIC" }]}
          >
            <Input
              style={{ width: "100%" }}
              value={nric}
              onChange={handleNricChange}
              disabled={!!nric || !nric}
            />
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 12}>
          <Space style={{ marginLeft: isMobile ? "0px" : "10%" }}>
            <Form.Item label="Birth Date">
              <DatePicker
                value={birthdate ? moment(birthdate, "YYYY-MM-DD") : null}
                onChange={(date, dateString) => setBirthdate(dateString)}
                disabled={!!birthdate || !birthdate}
              />
            </Form.Item>
          </Space>
        </Col>
      </Row>

      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="Principal Name">
            <Input
              style={{ width: "100%" }}
              value={principalname}
              onChange={(e) => setPrincipalName(e.target.value)}
              disabled={!!principalname || !principalname}
            />
          </Form.Item>
        </Col>

        <Col span={isMobile ? 24 : 12}>
          <Form.Item
            style={{ marginLeft: isMobile ? "0px" : "10%" }}
            label="Sex/Gender"
          >
            <Select
              value={gender}
              onChange={(value) => setGender(value)}
              disabled={!!gender || !gender}
            >
              <Option value="Male">Male</Option>
              <Option value="Female">Female</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={isMobile ? 24 : 8}>
          <Form.Item label="Race">
            <Select
              value={race}
              style={{ width: isMobile ? "100%" : "90%" }}
              onChange={(value) => setRace(value)}
              disabled={!!race || !race}
            >
              <Option value="John Smith">John Smith</Option>
              <Option value="Jane Doe">Jane Doe</Option>
              <Option value="Bob Johnson">Bob Johnson</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 8}>
          <Form.Item label="Residential Status">
            <Select
              value={residentialstatus}
              style={{ width: isMobile ? "100%" : "90%" }}
              onChange={(value) => setResidentialStatus(value)}
              disabled={!!residentialstatus || !residentialstatus}
            >
              <Option value="Singapore Citizen">Singapore Citizen</Option>
              <Option value="Permanent Resident">Permanent Resident</Option>
              <Option value="Foreigner">Foreigner</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 8}>
          <Form.Item label="Nationality">
            <Select
              value={nationality}
              style={{ width: isMobile ? "100%" : "90%" }}
              onChange={(value) => setNationality(value)}
              disabled={!!nationality || !nationality}
            >
              <Option value="Singaporean">Singaporean</Option>
              <Option value="Malaysian">Malaysian</Option>
              <Option value="Chinese">Chinese</Option>
              <Option value="Indian">Indian</Option>
              <Option value="Other">Other</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="Country of Birth">
            <Select
              value={countryofbirth}
              style={{ width: "100%" }}
              onChange={(value) => setCountryOfBirth(value)}
              disabled={!!countryofbirth || !countryofbirth}
            >
              <Option value="Singapore">Singapore</Option>
              <Option value="Malaysia">Malaysia</Option>
              <Option value="China">China</Option>
              <Option value="India">India</Option>
              <Option value="Other">Other</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col span={isMobile ? 24 : 12}>
          <Form.Item
            style={{ marginLeft: isMobile ? "0px" : "10%" }}
            label="Owner of Private Residential Property"
            z
          >
            <Select
              value={ownerprivateresidentialproperty}
              onChange={(value) => setOwnerPrivateResidentialProperty(value)}
              disabled={
                !!ownerprivateresidentialproperty ||
                !ownerprivateresidentialproperty
              }
            >
              <Option value={false}>False</Option>
              <Option value={true}>True</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="Marital Status">
            <Input
              style={{ width: "100%" }}
              value={maritalStatus}
              onChange={(e) => setMaritalStatus(e.target.value)}
              disabled={!!maritalStatus || !maritalStatus}
            />
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item
            style={{ marginLeft: isMobile ? "0px" : "10%" }}
            label="Occupation"
          >
            <Input
              style={{ width: "100%" }}
              value={occupation}
              onChange={(e) => setOccupation(e.target.value)}
              disabled={!!occupation || !occupation}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="Employment Company">
            <Input
              style={{ width: "100%" }}
              value={employmentCompany}
              onChange={(e) => setEmploymentCompany(e.target.value)}
              disabled={!!employmentCompany || !employmentCompany}
            />
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item
            style={{ marginLeft: isMobile ? "0px" : "10%" }}
            label="Vehicle Type"
          >
            <Input
              style={{ width: "100%" }}
              value={vehicleType}
              onChange={(e) => setVehicleType(e.target.value)}
              disabled={!!vehicleType || !vehicleType}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={isMobile ? 24 : 8}>
          <Form.Item label="Pass Type">
            <Input
              value={passType}
              style={{ width: isMobile ? "100%" : "90%" }}
              onChange={(value) => setPassType(value)}
              disabled={!!passType || !passType}
            />
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 8}>
          <Form.Item label="Pass Status">
            <Input
              value={passStatus}
              style={{ width: isMobile ? "100%" : "90%" }}
              onChange={(value) => setPassStatus(value)}
              disabled={!!passStatus || !passStatus}
            />
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 8}>
          <Form.Item label="Pass Expiry Date">
            <Input
              value={passExpiryDate}
              style={{ width: isMobile ? "100%" : "90%" }}
              onChange={(value) => setPassExpiryDate(value)}
              disabled={!!passExpiryDate || !passExpiryDate}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="E-mail">
            <Input
              type="email"
              style={{ width: "100%" }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Item>
        </Col>

        <Col span={isMobile ? 24 : 12}>
          <Form.Item
            style={{ marginLeft: isMobile ? "0px" : "10%" }}
            label="Phone"
          >
            <Input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="Registered Address">
            <Input
              value={registeredaddress}
              style={{ width: "100%" }}
              onChange={(value) => setRegisteredAddress(value)}
              disabled={!!registeredaddress || !registeredaddress}
            />
          </Form.Item>
        </Col>

        <Col span={isMobile ? 24 : 12}>
          <Space style={{ marginLeft: isMobile ? "0px" : "10%" }}>
            <Form.Item label="Type of HDB">
              <Input
                value={typeOfHDB}
                style={{ width: "100%" }}
                onChange={(value) => setTypeOfHDB(value)}
                disabled={!!typeOfHDB || !typeOfHDB}
              />
            </Form.Item>
          </Space>
        </Col>
      </Row>
      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="Type of Housing">
            <Input
              value={typeOfHousing}
              style={{ width: isMobile ? "100%" : "90%" }}
              onChange={(value) => setTypeOfHousing(value)}
              disabled={!!typeOfHousing || !typeOfHousing}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={isMobile ? 24 : 6}>
          <Form.Item label="CPF OA Balance">
            <Input
              value={cpfOrdinaryAccount}
              style={{ width: isMobile ? "100%" : "90%" }}
              onChange={(e) => setCpfOrdinaryAccount(e.target.value)}
              disabled={!!cpfOrdinaryAccount || !cpfOrdinaryAccount}
            />
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 6}>
          <Form.Item label="CPF SA Balance">
            <Input
              value={cpfSpecialAccount}
              style={{ width: isMobile ? "100%" : "90%" }}
              onChange={(e) => setCpfSpecialAccount(e.target.value)}
              disabled={!!cpfSpecialAccount || !cpfSpecialAccount}
            />
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 6}>
          <Form.Item label="CPF MA Balance">
            <Input
              value={cpfMedisaveAccount}
              style={{ width: isMobile ? "100%" : "90%" }}
              onChange={(e) => setCpfMedisaveAccount(e.target.value)}
              disabled={!!cpfMedisaveAccount || !cpfMedisaveAccount}
            />
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 6}>
          <Form.Item label="CPF RA Balance">
            <Input
              value={cpfRetirementAccount}
              style={{ width: isMobile ? "100%" : "90%" }}
              onChange={(e) => setCpfRetirementAccount(e.target.value)}
              disabled={!!cpfRetirementAccount || !cpfRetirementAccount}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="Latest CPF Contribution">
            <Input
              value={latestCpfContribution}
              style={{ width: "100%" }}
              onChange={(e) => setLatestCpfContribution(e.target.value)}
              disabled={!!latestCpfContribution || !latestCpfContribution}
            />
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item
            style={{ marginLeft: isMobile ? "0px" : "10%" }}
            label="Latest NOA Year"
          >
            <Input
              value={latestNoaYear}
              style={{ width: "100%" }}
              onChange={(e) => setLatestNoaYear(e.target.value)}
              disabled={!!latestNoaYear || !latestNoaYear}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="Latest NOA Amount">
            <Input
              value={latestNoaAmount}
              style={{ width: "100%" }}
              onChange={(e) => setLatestNoaAmount(e.target.value)}
              disabled={!!latestNoaAmount || !latestNoaAmount}
            />
          </Form.Item>
        </Col>
      </Row>
      {/* <div style={{ display: "flex", gap: "10px" }}>
        <div
          style={{
            padding: "6px 40px",
            border: "2px solid rgb(14, 90, 165)",
            color: "rgb(14, 90, 165)",
            fontWeight: 700,
            borderRadius: "20px",
          }}
        >
          Edit
        </div>
        <div
          style={{
            padding: "6px 40px",
            border: "2px solid rgb(14, 90, 165)",
            background: "rgb(14, 90, 165)",
            color: "white",
            fontWeight: 700,
            borderRadius: "20px",
          }}
        >
          Save
        </div>
      </div> */}
      {/* <Row>
                
        <Col span={isMobile ? 24 : 12}>
                    <Form.Item
                        label="Registered Address"
                        name="registeredaddress"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your registered address!',
                            },
                        ]}
                    >
                        <Input style={{ width: '100%' }} value={registeredaddress} onChange={(e) => setRegisteredAddress(e.target.value)} />
                    </Form.Item>
                </Col>
            </Row> */}

      <Form.Item {...tailLayout}>
        {/* <Button type="default" htmlType="button" style={{ color: "#0E5AA5", borderRadius: "20px", border: "1px solid #0E5AA5", width: screenWidth > 1200 ? "7%" :"20%" }}>
                    Edit
                </Button> */}
        {/* <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginLeft: '10px', borderRadius: "20px",  width: screenWidth > 1200 ? "7%" :"20%" }}
                    onClick={(event) => handleSave(event)}>
                    Save
                </Button> */}
      </Form.Item>
    </Form>
  );
};

const Property = () => {
  const { Option } = Select;
  const onChange = (date, dateString) => {
    console.log(date, dateString);
  };
  const [registeredAddress, setRegisteredAddress] = useState("");
  const [outstandingHDBLoanBalance, setOutstandingHDBLoanBalance] =
    useState("");
  const [typeOfHDBDwelling, setTypeOfHDBDwelling] = useState("");
  const [monthlyLoanInstallment, setMonthlyLoanInstallment] = useState("");
  const [cpfHousingWithdrawal, setCpfHousingWithdrawal] = useState([]);

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
    vertical: true,
  };

  const tailLayout = {
    wrapperCol: {
      offset: 0,
      span: 24,
    },
  };

  const onFinish = (values) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/singpass/getSingpassData",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const displaySingpassData = await response.json();
        const singpassPerson = getPersonData(displaySingpassData?.singpass_data) || {};
        const myinfoPerson = getMyInfoData(displaySingpassData?.myinfo_data) || {};
        const personDetail =
          Object.keys(myinfoPerson).length > 0 ? myinfoPerson : singpassPerson;
        const ownership =
          personDetail?.hdbownership?.[0] || singpassPerson?.hdbownership?.[0];
        const address = ownership?.address || personDetail?.regadd;

        setRegisteredAddress(
          address
            ? (address?.unit?.value !== null && address?.unit?.value !== undefined
                ? `Unit ${address?.unit?.value}, `
                : "") +
                (address?.floor?.value !== null && address?.floor?.value !== undefined
                  ? `Floor ${address?.floor?.value}, `
                  : "") +
                (address?.block?.value !== null && address?.block?.value !== undefined
                  ? `Block ${address?.block?.value}, `
                  : "") +
                (address?.street?.value !== null && address?.street?.value !== undefined
                  ? `${address?.street?.value}, `
                  : "") +
                (address?.postal?.value !== null && address?.postal?.value !== undefined
                  ? `${address?.postal?.value}, `
                  : "") +
                (address?.country?.desc !== null && address?.country?.desc !== undefined
                  ? `${address?.country?.desc}.`
                  : "")
            : ""
        );
        setOutstandingHDBLoanBalance(ownership?.outstandingloanbalance?.value || "");
        setCpfHousingWithdrawal(
          personDetail?.cpfhousingwithdrawal?.withdrawaldetails ||
            singpassPerson?.cpfhousingwithdrawal?.withdrawaldetails ||
            []
        );
        setTypeOfHDBDwelling(ownership?.hdbtype?.desc || personDetail?.hdbtype?.desc || "");
        setMonthlyLoanInstallment(ownership?.monthlyloaninstalment?.value || "");
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  const [screenWidth, setScreenWidth] = useState(1920);
  const [isMobile, setIsMobile] = useState(
    Cookies.get("ismobile") === "yes" ? true : false
  );
  useEffect(() => {
    if (screenWidth < 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Form
      style={{ minHeight: isMobile ? "auto" : "73vh" }}
      {...layout}
      name="basic"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <div style={{ marginTop: "10px" }}>
        <div style={{ fontWeight: 400, fontSize: "18px" }}>
          CPF Housing Withdrawal
        </div>
        {cpfHousingWithdrawal
          ? cpfHousingWithdrawal.map((cpf, index) => (
              <div key={index}>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    width: "100%",
                    marginTop: "15px",
                  }}
                >
                  <div style={{ width: isMobile ? "100%" : "33%" }}>
                    <Form.Item label="Address">
                      <Input
                        style={{ width: "90%" }}
                        value={
                          (cpf.address.unit?.value !== undefined
                            ? `Unit ${cpf.address.unit?.value}, `
                            : "") +
                          (cpf.address.floor?.value !== undefined
                            ? `Floor ${cpf.address.floor?.value}, `
                            : "") +
                          (cpf.address.block?.value !== undefined
                            ? `Block ${cpf.address.block?.value}, `
                            : "") +
                          (cpf.address.street?.value !== undefined
                            ? `${cpf.address.street?.value}, `
                            : "") +
                          (cpf.address.postal?.value !== undefined
                            ? `${cpf.address.postal?.value}, `
                            : "") +
                          (cpf.address.country?.desc !== undefined
                            ? `${cpf.address.country?.desc}.`
                            : "")
                        }
                        // onChange={(value) => console.log(value)}
                        disabled={
                          !!monthlyLoanInstallment || !monthlyLoanInstallment
                        }
                      />
                    </Form.Item>
                  </div>
                  <div style={{ width: isMobile ? "100%" : "33%" }}>
                    <Form.Item label="Principal Withdrawal Amount">
                      <Input
                        style={{ width: "90%" }}
                        value={cpf?.principalwithdrawalamt?.value?.toLocaleString(
                          "en-US",
                          {
                            style: "currency",
                            currency: "SGD",
                          }
                        )}
                        // onChange={(value) => console.log(value)}
                        disabled={
                          !!monthlyLoanInstallment || !monthlyLoanInstallment
                        }
                      />
                    </Form.Item>
                  </div>
                  <div style={{ width: isMobile ? "100%" : "33%" }}>
                    <Form.Item label="Monthly Installment Amount">
                      <Input
                        style={{ width: "90%" }}
                        value={cpf?.monthlyinstalmentamt?.value?.toLocaleString(
                          "en-US",
                          {
                            style: "currency",
                            currency: "SGD",
                          }
                        )}
                        // onChange={(value) => console.log(value)}
                        disabled={
                          !!monthlyLoanInstallment || !monthlyLoanInstallment
                        }
                      />
                    </Form.Item>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <div style={{ width: isMobile ? "100%" : "33%" }}>
                    <Form.Item label="Accrued Interest Amount">
                      <Input
                        style={{ width: "90%" }}
                        value={cpf?.accruedinterestamt?.value?.toLocaleString(
                          "en-US",
                          {
                            style: "currency",
                            currency: "SGD",
                          }
                        )}
                        // onChange={(value) => console.log(value)}
                        disabled={
                          !!monthlyLoanInstallment || !monthlyLoanInstallment
                        }
                      />
                    </Form.Item>
                  </div>
                  <div style={{ width: isMobile ? "100%" : "33%" }}>
                    <Form.Item label="Total Amount of CPF Allowed for Property">
                      <Input
                        style={{ width: "90%" }}
                        value={cpf?.totalamountofcpfallowedforproperty?.value?.toLocaleString(
                          "en-US",
                          {
                            style: "currency",
                            currency: "SGD",
                          }
                        )}
                        // onChange={(value) => console.log(value)}
                        disabled={
                          !!monthlyLoanInstallment || !monthlyLoanInstallment
                        }
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>
            ))
          : null}
      </div>

      <Row>
        <hr style={{ color: "grey", width: "100%" }} />
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item label="Registered Address">
            <Input
              style={{ width: isMobile ? "90%" : "96.5%" }}
              value={registeredAddress}
              onChange={(value) => setRegisteredAddress(value)}
              disabled={!!registeredAddress || !registeredAddress}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={isMobile ? 24 : 8}>
          <Form.Item label="Type of HDB Dwelling">
            <Input
              style={{ width: "90%" }}
              value={typeOfHDBDwelling}
              onChange={(value) => setTypeOfHDBDwelling(value)}
              disabled={!!typeOfHDBDwelling || !typeOfHDBDwelling}
            />
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 8}>
          <Form.Item label="Outstanding HDB Loan Balance">
            <Input
              style={{ width: "90%" }}
              value={parseFloat(outstandingHDBLoanBalance).toLocaleString(
                "en-US",
                {
                  style: "currency",
                  currency: "SGD",
                }
              )}
              onChange={(value) => setOutstandingHDBLoanBalance(value)}
              disabled={
                !!outstandingHDBLoanBalance || !outstandingHDBLoanBalance
              }
            />
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 8}>
          <Form.Item label="Monthly Loan Installment">
            <Input
              style={{ width: "90%" }}
              value={parseFloat(monthlyLoanInstallment).toLocaleString(
                "en-US",
                {
                  style: "currency",
                  currency: "SGD",
                }
              )}
              onChange={(value) => setMonthlyLoanInstallment(value)}
              disabled={!!monthlyLoanInstallment || !monthlyLoanInstallment}
            />
          </Form.Item>
        </Col>
      </Row>
      {/* <div style={{ display: "flex", gap: "10px" }}>
        <div
          style={{
            padding: "6px 40px",
            border: "2px solid rgb(14, 90, 165)",
            color: "rgb(14, 90, 165)",
            fontWeight: 700,
            borderRadius: "20px",
          }}
        >
          Edit
        </div>
        <div
          style={{
            padding: "6px 40px",
            border: "2px solid rgb(14, 90, 165)",
            background: "rgb(14, 90, 165)",
            color: "white",
            fontWeight: 700,
            borderRadius: "20px",
          }}
        >
          Save
        </div>
      </div> */}
    </Form>
  );
};

const Employment = () => {
  const [employerName, setEmployerName] = useState("");
  const [employementSector, setEmployementSector] = useState("");
  const [occupation, setOccupation] = useState("");

  const parseMaybeJson = (value) => {
    if (!value) return null;
    if (typeof value === "object") return value;

    try {
      return JSON.parse(value);
    } catch (error) {
      console.error("Failed to parse JSON payload", error);
      return null;
    }
  };

  const pickFirst = (...values) =>
    values.find((value) => value !== null && value !== undefined && value !== "");

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
    vertical: true,
  };

  const onFinish = (values) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/singpass/getSingpassData",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const displaySingpassData = await response.json();
        const singpassData = parseMaybeJson(displaySingpassData?.singpass_data);
        const myinfoData = parseMaybeJson(displaySingpassData?.myinfo_data);
        const singpassPerson = getPersonData(singpassData) || {};
        const myinfoPerson = getMyInfoData(myinfoData) || {};

        setEmployerName(
          pickFirst(myinfoPerson?.employment?.value, singpassPerson?.employment?.value, "")
        );
        setEmployementSector(
          pickFirst(
            myinfoPerson?.employmentsector?.value,
            singpassPerson?.employmentsector?.value,
            ""
          )
        );
        setOccupation(
          pickFirst(myinfoPerson?.occupation?.value, singpassPerson?.occupation?.value, "")
        );
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  const [screenWidth, setScreenWidth] = useState(1920);
  const [isMobile, setIsMobile] = useState(
    Cookies.get("ismobile") === "yes" ? true : false
  );
  useEffect(() => {
    if (screenWidth < 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Form
      style={{ minHeight: "73vh" }}
      {...layout}
      name="basic"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="Employer Name">
            <Input
              type="text"
              style={{ width: "95%" }}
              value={employerName}
              onChange={(value) => setEmployerName(value)}
              disabled={!!employerName || !employerName}
            />
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item
            style={{ marginLeft: isMobile ? "0px" : "5%" }}
            label="Occupation"
          >
            <Input
              type="text"
              style={{ width: "95%" }}
              value={occupation}
              onChange={(value) => setOccupation(value)}
              disabled={!!occupation || !occupation}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="Employment Sector">
            <Input
              type="text"
              style={{ width: "95%" }}
              value={employementSector}
              onChange={(value) => setEmployementSector(value)}
              disabled={!!employementSector || !employementSector}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

const Family = () => {
  const { Option } = Select;
  const onChange = (date, dateString) => {
    console.log(date, dateString);
  };
  const [maritalStatus, setMaritalStatus] = useState("");

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
    vertical: true,
  };

  const tailLayout = {
    wrapperCol: {
      offset: 0,
      span: 24,
    },
  };

  const onFinish = (values) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/singpass/getSingpassData",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const displaySingpassData = await response.json();
        const singpassPerson = getPersonData(displaySingpassData?.singpass_data) || {};
        const myinfoPerson = getMyInfoData(displaySingpassData?.myinfo_data) || {};
        setMaritalStatus(
          myinfoPerson?.marital?.desc || singpassPerson?.marital?.desc || ""
        );
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  const [screenWidth, setScreenWidth] = useState(1920);
  const [isMobile, setIsMobile] = useState(
    Cookies.get("ismobile") === "yes" ? true : false
  );
  useEffect(() => {
    if (screenWidth < 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Form
      style={{ minHeight: isMobile ? "auto" : "73vh" }}
      {...layout}
      name="basic"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="Marital Status">
            <Input
              type="text"
              style={{ width: "95%" }}
              value={maritalStatus}
              onChange={(value) => setMaritalStatus(value)}
              // disabled={!!maritalStatus || !maritalStatus}
            />
          </Form.Item>
        </Col>
      </Row>
      {/* <div style={{ display: "flex", gap: "10px" }}>
        <div
          style={{
            padding: "6px 40px",
            border: "2px solid rgb(14, 90, 165)",
            color: "rgb(14, 90, 165)",
            fontWeight: 700,
            borderRadius: "20px",
          }}
        >
          Edit
        </div>
        <div
          style={{
            padding: "6px 40px",
            border: "2px solid rgb(14, 90, 165)",
            background: "rgb(14, 90, 165)",
            color: "white",
            fontWeight: 700,
            borderRadius: "20px",
          }}
        >
          Save
        </div>
      </div> */}

      {/* <Form.Item {...tailLayout}>
            <Button type="default" htmlType="button">
              Edit
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginLeft: "10px" }}
            >
              Save
            </Button>
          </Form.Item> */}
    </Form>
  );
};

const Vehicle = () => {
  const { Option } = Select;
  const onChange = (date, dateString) => {
    console.log(date, dateString);
  };
  const [vehicleModel, setVehicleModel] = useState("");
  const [vehicleMade, setVehicleMade] = useState("");
  const [vehicleNumber, setVehicleNumber] = useState("");

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
    vertical: true,
  };

  const tailLayout = {
    wrapperCol: {
      offset: 0,
      span: 24,
    },
  };

  const onFinish = (values) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/singpass/getSingpassData",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const displaySingpassData = await response.json();
        const singpassPerson = getPersonData(displaySingpassData?.singpass_data) || {};
        const myinfoPerson = getMyInfoData(displaySingpassData?.myinfo_data) || {};
        const myinfoVehicle = myinfoPerson?.vehicles?.[0] || {};
        const singpassVehicle = singpassPerson?.vehicles?.[0] || {};

        setVehicleModel(
          myinfoVehicle?.model?.value ||
            singpassVehicle?.model?.value ||
            myinfoVehicle?.type?.value ||
            singpassVehicle?.type?.value ||
            ""
        );
        setVehicleMade(
          myinfoVehicle?.make?.value || singpassVehicle?.make?.value || ""
        );
        setVehicleNumber(
          myinfoVehicle?.vehicleno?.value || singpassVehicle?.vehicleno?.value || ""
        );
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  const [screenWidth, setScreenWidth] = useState(1920);
  const [isMobile, setIsMobile] = useState(
    Cookies.get("ismobile") === "yes" ? true : false
  );
  useEffect(() => {
    if (screenWidth < 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Form
      style={{ minHeight: isMobile ? "auto" : "73vh" }}
      {...layout}
      name="basic"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="Vehicle Model">
            <Input
              type="text"
              style={{ width: "90%" }}
              value={vehicleModel}
              onChange={(value) => setVehicleModel(value)}
              disabled={!!vehicleModel || !vehicleModel}
            />
          </Form.Item>
        </Col>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item
            style={{ marginLeft: isMobile ? "0px" : "5%" }}
            label="Vehicle Make"
          >
            <Input
              type="text"
              style={{ width: "90%" }}
              value={vehicleMade}
              onChange={(value) => setVehicleMade(value)}
              disabled={!!vehicleMade || !vehicleMade}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={isMobile ? 24 : 12}>
          <Form.Item label="Vehicle Number">
            <Input
              type="text"
              style={{ width: "90%" }}
              value={vehicleNumber}
              onChange={(value) => setVehicleNumber(value)}
              disabled={!!vehicleNumber || !vehicleNumber}
            />
          </Form.Item>
        </Col>
      </Row>

      {/* <Form.Item {...tailLayout}>
            <Button type="default" htmlType="button">
              Edit
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginLeft: "10px" }}
            >
              Save
            </Button>
          </Form.Item> */}
      {/* <div style={{ display: "flex", gap: "10px" }}>
        <div
          style={{
            padding: "6px 40px",
            border: "2px solid rgb(14, 90, 165)",
            color: "rgb(14, 90, 165)",
            fontWeight: 700,
            borderRadius: "20px",
          }}
        >
          Edit
        </div>
        <div
          style={{
            padding: "6px 40px",
            border: "2px solid rgb(14, 90, 165)",
            background: "rgb(14, 90, 165)",
            color: "white",
            fontWeight: 700,
            borderRadius: "20px",
          }}
        >
          Save
        </div>
      </div> */}
    </Form>
  );
};

const Finance = () => {
  const tailLayout = {
    wrapperCol: {
      offset: 0,
      span: 24,
    },
  };

  const table1titleStyle = {
    textAlign: "left",
    width: "1%",
    fontWeight: "bold",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: "200",
  };

  const table1dataStyle = {
    textAlign: "left",
    width: "1%",
    fontWeight: "200",
    fontFamily: "Poppins",
    fontSize: "14px",
    // borderBottom: "1px solid red",
  };

  const table2titleStyle = {
    textAlign: "left",
    width: "1%",
    fontWeight: "bold",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: "200",
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-"; // Return a default value if the date string is not provided

    const date = new Date(dateString); // Create a Date object from the date string
    const formattedDate = format(date, "MMMM yyyy"); // Use date-fns to format the date in the desired format

    return formattedDate;
  };

  const formatDate2 = (dateString) => {
    if (!dateString) return "-"; // Return a default value if the date string is not provided

    const date = new Date(dateString); // Create a Date object from the date string
    const formattedDate = format(date, "dd MMMM yyyy"); // Use date-fns to format the date in the desired format

    return formattedDate;
  };

  const columns = [
    // {
    //   dataIndex: "",
    //   key: "account_balance",
    //   render: (text, record) => (
    //     <td style={table1titleStyle}>
    //       Ordinary Account (OA)
    //       <hr style={{ width: "100%" }} />
    //       Special Account (SA)
    //       <hr style={{ width: "100%" }} />
    //       Medisave Account (MA)
    //       <hr style={{ width: "100%" }} />
    //       Retirement Account (RA)
    //     </td>
    //   ),
    // },
    // {
    //   dataIndex: "",
    //   key: "account_balance",
    //   render: (text, record) => (
    //     <td style={table1dataStyle}>
    //       {record.oa.value.toLocaleString("en-US", {
    //         style: "currency",
    //         currency: "SGD",
    //       })}
    //       <hr style={{ width: "100%" }} />
    //       {record.sa.value.toLocaleString("en-US", {
    //         style: "currency",
    //         currency: "SGD",
    //       })}
    //       <hr style={{ width: "100%" }} />
    //       {record.ma.value.toLocaleString("en-US", {
    //         style: "currency",
    //         currency: "SGD",
    //       })}
    //       <hr style={{ width: "100%" }} />
    //       {record.ra.value.toLocaleString("en-US", {
    //         style: "currency",
    //         currency: "SGD",
    //       })}
    //     </td>
    //   ),
    // },
    {
      title: "Account Type",
      dataIndex: "accountType",
      key: "accountType",
    },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
      render: (balance) =>
        balance.toLocaleString("en-US", {
          style: "currency",
          currency: "SGD",
        }),
    },
  ];
  const columns2 = [
    {
      title: <span style={table2titleStyle}>Year of Assessment</span>,
      dataIndex: "yearofassessment",
      key: "yearofassessment",
      render: (text) => (
        <a
          style={{
            fontWeight: "400",
            fontFamily: "Manrope",
            fontSize: "14px",
          }}
        >
          {text}
        </a>
      ),
    },
    {
      title: <span style={table2titleStyle}>Description</span>,
      dataIndex: "category",
      key: "category",
      render: (text) => (
        <a
          style={{
            fontWeight: "400",
            fontFamily: "Manrope",
            fontSize: "14px",
          }}
        >
          {text}
        </a>
      ),
    },
    {
      title: <span style={table2titleStyle}>Amount ($)</span>,
      dataIndex: "amount",
      key: "amount",
      render: (text) => (
        <a
          style={{
            fontWeight: "400",
            fontFamily: "Manrope",
            fontSize: "14px",
          }}
        >
          {text.toLocaleString("en-US", { style: "currency", currency: "SGD" })}
        </a>
      ),
    },
  ];
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);

  // useEffect(() => {
  //   async function fetchData() {
  //     const headers = new Headers();
  //     headers.append("Content-Type", "application/json");
  //     headers.append("Authorization", "Bearer " + Cookies.get("token"));

  //     const options = {
  //       method: "GET",
  //       headers: headers,
  //     };

  //     try {
  //       const response = await fetch(
  //         "https://www.smart-lend.com/api/profile/viewPersonal?type=Finance",
  //         options
  //       );

  //       if (!response.ok) {
  //         throw new Error("Failed to fetch data");
  //       }

  //       const responseData = await response.json();
  //       setData(responseData["CPF Contribution History"]);
  //       setData2(responseData["Finance Account Balance"]);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   }
  //   fetchData();
  // }, []);

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/singpass/getSingpassData",
          options
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const displaySingpassData = await response.json();
        const singpassNoa =
          getPersonData(displaySingpassData?.singpass_data)?.noahistory?.noas || [];
        const myinfoNoa = getMyInfoData(displaySingpassData?.myinfo_data)?.noahistory?.noas || [];
        const personDetail = myinfoNoa.length > 0 ? myinfoNoa : singpassNoa;

        const historyData = personDetail.map((item, index) => ({
          key: index.toString(),
          yearofassessment: item?.yearofassessment?.value,
          category: item?.category?.value,
          amount: parseFloat(item?.amount?.value || 0).toLocaleString("en-US", {
            style: "currency",
            currency: "SGD",
          }),
        }));
        console.log("history data:", historyData);
        setData2(historyData);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  const [screenWidth, setScreenWidth] = useState(1920);
  const [isMobile, setIsMobile] = useState(Cookies.get("ismobile") === "yes");

  useEffect(() => {
    if (screenWidth < 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div style={{ minHeight: isMobile ? "auto" : "73vh" }}>
      <h5
        style={{
          marginTop: "20px",
          marginBottom: "10px",
          fontWeight: "800",
          fontFamily: "Manrope",
          fontSize: "18px",
        }}
      >
        Notice of Assessment
      </h5>
      <Table
        columns={columns2}
        dataSource={data2}
        pagination={false}
        bordered
        style={{
          width: screenWidth > 1200 ? "60%" : "100%",
          border: "1px solid #979797",
          borderRadius: "10px",
          overflow: "hidden", // To make sure borderRadius applies to all inner elements
        }}
      />{" "}
      {/* <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
        <div
          style={{
            padding: "6px 40px",
            border: "2px solid rgb(14, 90, 165)",
            color: "rgb(14, 90, 165)",
            fontWeight: 700,
            borderRadius: "20px",
          }}
        >
          Edit
        </div>
        <div
          style={{
            padding: "6px 40px",
            border: "2px solid rgb(14, 90, 165)",
            background: "rgb(14, 90, 165)",
            color: "white",
            fontWeight: 700,
            borderRadius: "20px",
          }}
        >
          Save
        </div>
      </div> */}
    </div>
  );
};

const ProfileStaging = () => {
  const history = useHistory();
  const location = useLocation();
  const approvedPersonalSingpassButton = location.pathname === "/stg-b-profile";
  const [activeMainTab, setActiveMainTab] = useState("1");
  useEffect(() => {
    console.log(activeMainTab);
  }, [activeMainTab]);

  const redirectToUrl = (path) => {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get("code");
    const state = searchParams.get("state");

    let redirectTo = path;

    if (code && state) {
      redirectTo += `?code=${code}&state=${state}`;
    }

    history.push(redirectTo);
  };

  const isCrmSyncState = (state) =>
    typeof state === "string" && state.startsWith("slcrm_") && !hasNetrustTrialContext(state);

  useEffect(() => {
    const currentURL = new URL(window.location.href);
    const code = currentURL.searchParams.get("code");
    const state = currentURL.searchParams.get("state");
    const error = currentURL.searchParams.get("error");

    if (isCrmSyncState(state)) {
      return;
    }

    const supportSyncContext = Cookies.get("support_sync_context");
    if (!supportSyncContext || hasNetrustTrialContext(state)) {
      return;
    }

    if (code || state || error) {
      history.replace(`/cs-dashboard${window.location.search}`);
    }
  }, [history]);

  useEffect(() => {
    const currentURL = new URL(window.location.href);
    const code = currentURL.searchParams.get("code");
    const state = currentURL.searchParams.get("state");
    const error = currentURL.searchParams.get("error");

    if ((code || error) && isCrmSyncState(state)) {
      history.replace(`/b-auth-conf${window.location.search}`);
    }
  }, [history]);

  useEffect(() => {
    if (Cookies.get("token")) {
      console.log("Cookies exist");
      // } else {
      //   console.log("Cookies don't exist and redirect to www.gmail.com");
      //   redirectToUrl("/director-authorization");
      // }
    }
  }, [Cookies.get("token")]);
  const [dataActivityLog, setActivityLog] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [activeData, setActiveData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [displayAds, setDisplayAds] = useState([]);
  const [adImage, setAdImage] = useState(null);
  const [adLink, setAdLink] = useState(null);

  const { TabPane } = Tabs;
  const singpass_sync = Cookies.get("singpass_sync");

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [singpassData, setSingpassData] = useState(null);
  const [savedBusinessData, setSavedBusinessData] = useState(null);
  const [isSavingBusiness, setIsSavingBusiness] = useState(false);
  const openBusinessAssistance = () => window.open("https://wa.me/6587853373?text=I%20would%20like%20help%20with%20a%20manual%20business%20application%20without%20Myinfo%20Business", "_blank", "noopener,noreferrer");
  const [urlCode, setUrlCode] = useState(null);
  const [sexDetail, setSexDetail] = useState(null);
  const [nric2, setNRIC2] = useState("");
  const [nric, setNRIC] = useState("");
  const [fullName2, setFullName2] = useState("");
  const [fullName, setFullName] = useState("");
  const [sex, setSex] = useState("");
  const [sex2, setSex2] = useState("");
  const [race, setRace] = useState("");
  const [race2, setRace2] = useState("");
  const [nationality, setNationality] = useState("");
  const [nationality2, setNationality2] = useState("");
  const [dob, setDOB] = useState("");
  const [dob2, setDOB2] = useState("");
  const [countryOfBirth, setCountryOfBirth] = useState("");
  const [countryOfBirth2, setCountryOfBirth2] = useState("");
  const [residentialStatus, setResidentialStatus] = useState("");
  const [residentialStatus2, setResidentialStatus2] = useState("");
  const [passType, setPassType] = useState("");
  const [passType2, setPassType2] = useState("");
  const [passStatus, setPassStatus] = useState("");
  const [passStatus2, setPassStatus2] = useState("");
  const [passExpiryDate, setPassExpiryDate] = useState("");
  const [passExpiryDate2, setPassExpiryDate2] = useState("");
  const [privatePropertyStatus, setPrivatePropertyStatus] = useState("");
  const [privatePropertyStatus2, setPrivatePropertyStatus2] = useState("");
  const [occupation, setOccupation] = useState("");
  const [occupation2, setOccupation2] = useState("");
  const [employerName, setEmployerName] = useState("");
  const [employerName2, setEmployerName2] = useState("");
  const [employmentSector, setEmploymentSector] = useState("");
  const [employmentSector2, setEmploymentSector2] = useState("");
  const [hdbType, setHDBType] = useState("");
  const [hdbType2, setHDBType2] = useState("");
  const [hdbAddress, setHDBAddress] = useState("");
  const [hdbAddress2, setHDBAddress2] = useState("");
  const [hdbOutstandingLoanBalance, setHDBOutstandingLoanBalance] =
    useState("");
  const [hdbOutstandingLoanBalance2, setHDBOutstandingLoanBalance2] =
    useState("");
  const [hdbMonthlyLoanInstallment, setHDBMonthlyLoanInstallment] =
    useState("");
  const [hdbMonthlyLoanInstallment2, setHDBMonthlyLoanInstallment2] =
    useState("");
  const [hdbTypeDwelling, setHDBTypeDwelling] = useState("");
  const [hdbTypeDwelling2, setHDBTypeDwelling2] = useState("");
  const [vehiclesModel, setVehiclesModel] = useState("");
  const [vehiclesModel2, setVehiclesModel2] = useState("");
  const [vehiclesMake, setVehiclesMake] = useState("");
  const [vehiclesMake2, setVehiclesMake2] = useState("");
  const [noaHistory, setNoaHistory] = useState([]);

  const [email, setEmail] = useState("");
  const [email2, setEmail2] = useState("");
  const [mobile_number, setMobileNumber] = useState("");
  const [mobile_number2, setMobileNumber2] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [maritalStatus2, setMaritalStatus2] = useState("");
  const [uen, setUEN] = useState("");
  const [uen2, setUEN2] = useState("");
  const [entityName, setEntityName] = useState("");
  const [entityName2, setEntityName2] = useState("");
  const [entityType, setEntityType] = useState("");
  const [entityType2, setEntityType2] = useState("");
  const [entityStatus, setEntityStatus] = useState("");
  const [entityStatus2, setEntityStatus2] = useState("");
  const [registeredAddress, setRegisteredAddress] = useState("");
  const [registeredAddress2, setRegisteredAddress2] = useState("");
  const [registeredAddressEntity, setRegisteredAddressEntity] = useState("");
  const [registeredAddressEntity2, setRegisteredAddressEntity2] = useState("");
  const [housingType, setHousingType] = useState("");
  const [housingType2, setHousingType2] = useState("");
  const [highestEducationLevel, setHighestEducationLevel] = useState("");
  const [highestEducationLevel2, setHighestEducationLevel2] = useState("");
  const [registrationDate, setRegistrationDate] = useState("");
  const [registrationDate2, setRegistrationDate2] = useState("");
  const [primarySSIC, setPrimarySSIC] = useState("");
  const [primarySSIC2, setPrimarySSIC2] = useState("");
  const [secondarySSIC, setSecondarySSIC] = useState("");
  const [secondarySSIC2, setSecondarySSIC2] = useState("");
  const [appointment1Position, setAppointment1Position] = useState("");
  const [appointment1Position2, setAppointment1Position2] = useState("");
  const [appointment1NRIC, setAppointment1NRIC] = useState("");
  const [appointment1NRIC2, setAppointment1NRIC2] = useState("");
  const [appointment1FullName, setAppointment1FullName] = useState("");
  const [appointment1FullName2, setAppointment1FullName2] = useState("");
  const [appointment1AppointmentDate, setAppointment1AppointmentDate] =
    useState("");
  const [appointment1AppointmentDate2, setAppointment1AppointmentDate2] =
    useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [capitals, setCapitals] = useState([]);
  const [financials, setFinancials] = useState([]);
  const [grants, setGrants] = useState([]);
  const [previousUens, setPreviousUens] = useState([]);
  const [shareholders, setShareholders] = useState([]);

  const [nricError, setNricError] = useState(false);
  const [fullNameError, setFullNameError] = useState(false);
  const [sexError, setSexError] = useState(false);
  const [raceError, setRaceError] = useState(false);
  const [nationalityError, setNationalityError] = useState(false);
  const [dobError, setDOBError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [mobileNoError, setMobileNoError] = useState(false);
  const [registeredAddressError, setRegisteredAddressError] = useState(false);
  const [housingTypeError, setHousingTypeError] = useState(false);
  const [maritalStatusError, setMaritalStatusError] = useState(false);
  const [highestEducationLevelError, setHighestEducationLevelError] =
    useState(false);
  const [uenError, setUENError] = useState(false);
  const [entityNameError, setEntityNameError] = useState(false);
  const [entityTypeError, setEntityTypeError] = useState(false);
  const [entityStatusError, setEntityStatusError] = useState(false);
  const [registeredAddressEntityError, setRegisteredAddressEntityError] =
    useState(false);
  const [registrationDateError, setRegistrationDateError] = useState(false);
  const [primarySSICError, setPrimarySSICError] = useState(false);
  const [secondarySSICError, setSecondarySSICError] = useState(false);
  const [appointment1PositionError, setAppointment1PositionError] =
    useState(false);
  const [appointment1NRICError, setAppointment1NRICError] = useState(false);
  const [appointment1FullNameError, setAppointment1FullNameError] =
    useState(false);
  const [appointment1DateError, setAppointment1DateError] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [verifiedStatus, setVerifiedStatus] = useState(0);

  const updateUserVerificationFiles = async (data) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/user/updateUserVerificationFiles`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify({
            verification_files: JSON.stringify(data),
          }),
        }
      );

      if (response.ok) {
        const json = await response.json();
        console.log(json);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onFileSelected = async (files) => {
    try {
      let uploadedFileUrl = [];
      for (const file of files) {
        console.log(file);
        const formData = new FormData();
        formData.append("file", file);
        const response = await fetch(
          `https://www.smart-lend.com/api/file/uploadUniversalFile`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
            },
            body: formData,
          }
        );
        if (response.ok) {
          const json = await response.json();
          uploadedFileUrl.push({ name: file.name, url: json.url });
        }
      }
      const updatedverificationfiles = [...uploadedFiles, ...uploadedFileUrl];
      setUploadedFiles([...uploadedFiles, ...uploadedFileUrl]);
      updateUserVerificationFiles(updatedverificationfiles);
    } catch (error) {
      console.error(error);
    }
  };

  const getUserVerificationFiles = async () => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/user/getUserVerificationFiles`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
        }
      );

      if (response.ok) {
        const json = await response.json();
        if (JSON.parse(json.verification_files)) {
          setUploadedFiles(JSON.parse(json.verification_files));
        }
        if (json.verificationStatus) {
          setVerifiedStatus(json.verificationStatus);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getUserVerificationFiles();
  }, []);

  const [notSameEntityModalIsOpen, setNotSameEntityModalIsOpen] =
    useState(false);

  const [sameAsOtherEntityModalIsOpen, setSameAsOtherEntityModalIsOpen] =
    useState(false);
  function isEntityNameInList(entityName, allEntitiesName) {
    return allEntitiesName.includes(entityName);
  }

  const [showSingpassError, setShowSingpassError] = useState(false);
  const [showCorporateLoanPrompt, setShowCorporateLoanPrompt] = useState(false);

  useEffect(() => {
    const currentURL = new URL(window.location.href);
    const code = currentURL.searchParams.get("code");
    const state = currentURL.searchParams.get("state");
    const error = currentURL.searchParams.get("error");
    if (isCrmSyncState(state) || (Cookies.get("support_sync_context") && !hasNetrustTrialContext(state))) return;
    const expressAuth = isNetrustTrialCallback() ? null : Cookies.get("expressauth");
    if (expressAuth && code) { redirectToUrl("/director-authorization"); return; }
    const cleanCallback = () => {
      ["code", "state", "error", "error_description"].forEach(key => currentURL.searchParams.delete(key));
      window.history.replaceState({}, document.title, currentURL.toString());
    };
    if (error) { setShowSingpassError(true); cleanCallback(); return; }
    if (!code) return;
    let cancelled = false;
    const retrieve = async () => {
      setIsLoading(true);
      try {
        const trial = netrustTrialResolveRequest("corppass", code, state);
        const response = await fetch(trial?.url || "https://www.smart-lend.com/api/singpass/resolveTokens", {
          method: "POST", headers: { "Content-Type": "application/json", Authorization: "Bearer " + Cookies.get("token") },
          body: JSON.stringify(trial?.body || { code, state }),
        });
        const data = await response.json();
        if (!response.ok || !(data?.entity?.["basic-profile"] || data?.entity_info?.basic_profile) || data.error || data.errorMessage) throw new Error("Retrieval failed");
        if (cancelled) return;
        setSingpassData(data);
        setIsModalVisible(true);
        setActiveMainTab("2");
      } catch {
        if (!cancelled) { setSingpassData(null); setIsModalVisible(false); setShowSingpassError(true); }
      } finally {
        if (!cancelled) { setIsLoading(false); cleanCallback(); }
      }
    };
    retrieve();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    const showPrompt = sessionStorage.getItem("showCorporateLoanPrompt");
    if (showPrompt === "true") {
      setShowCorporateLoanPrompt(true);
      sessionStorage.removeItem("showCorporateLoanPrompt");
    }
  }, []);

  const fetchActiveData = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/profile/getUserActive",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + Cookies.get("token"),
            Accept: "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }
      const json = await response.json();
      console.log(json.data);
      setActiveData(json.data);
    } catch (error) {
      console.log(error);
    }
  };

  const discardBusinessReview = async () => {
    if (isSavingBusiness) return;
    setIsModalVisible(false);
    setSingpassData(null);
  };

  const handleSave = async (overrides = {}) => {
    if (isSavingBusiness || !singpassData) return;
    setIsSavingBusiness(true);
    try {
      const { business_review_token, ...snapshot } = singpassData;
      const response = await fetch("https://www.smart-lend.com/api/singpass/updateSingpassData", {
        method: "POST", headers: { "Content-Type": "application/json", Authorization: "Bearer " + Cookies.get("token") },
        body: JSON.stringify({ singpassData: snapshot, ...overrides }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || "Unable to save your details.");
      setSavedBusinessData(result.data || snapshot);
      setSingpassData(null);
      setIsModalVisible(false);
      setShowCorporateLoanPrompt(true);
      message.success("Myinfo Business details saved.");
      if (Cookies.get("sgpasscbs")) { Cookies.remove("sgpasscbs"); history.push("/b-cbs-campaign"); }
    } catch (err) {
      message.error(err.message || "Unable to save your details. Please try again.");
    } finally { setIsSavingBusiness(false); }
  };

  function formatDate(inputDate) {
    // Parse the input date string
    const date = new Date(inputDate);

    // Define month names
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Extract day, month, and year
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    // Format the date as "DD Mon, YYYY"
    const formattedDate = `${year}-${parseFloat(month) + 1}-${day}`;

    return formattedDate;
  }

  // const handleSave = async (event) => {
  //   event.preventDefault();

  //   setNricError(false);

  //   // Check for empty fields and set error states
  // if (!nric) {
  //   setNricError(true);
  //   return; // Exit the function if validation fails
  // }

  //   try {
  //     let item = {
  //       singpassDataBackup: singpassData,
  //     };
  //     const response = await fetch(
  //       `https://www.smart-lend.com/api/singpass/updateSingpassDataBackup`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: "Bearer " + Cookies.get("token"),
  //         },
  //         body: JSON.stringify(item), // Removed wrapping of item in an array
  //       }
  //     );
  //     const jsonSingpassData = await response.json();
  //     console.log("jsonSingpassData:", jsonSingpassData);

  //     if (response.status === 200) {
  //       try {
  //         let item2 = {

  //             singpass_data: {
  //               "entity": {

  //               },
  //               "person": {

  //               }
  //             }

  //         };
  //         const response2 = await fetch(
  //           `https://www.smart-lend.com/api/singpass/updateSingpassData`,
  //           {
  //             method: "POST",
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: "Bearer " + Cookies.get("token"),
  //             },
  //             body: JSON.stringify(item2),
  //           }
  //         );
  //         const jsonSingpassDataBackup = await response2.json();
  //         console.log("jsonSingpassDataBackup:", jsonSingpassDataBackup);

  //         setIsModalVisible(false);
  //         message.success("Successfully Sync With Singpass");
  //       } catch (err) {
  //         message.error(err);
  //       }
  //     }
  //   } catch (err) {
  //     message.error(err);
  //   }
  // };

  const onChange = (key) => {
    console.log(key);
  };
  const items = [
    {
      key: "1",
      label: `Basic Information`,
      children: <BasicInformation singpassData={singpassData} />,
    },
    {
      key: "2",
      label: `Finance`,
      children: <Finance />,
    },
    {
      key: "3",
      label: `Employement`,
      children: <Employment />,
    },
    {
      key: "4",
      label: `Property`,
      children: <Property />,
    },
    {
      key: "5",
      label: `Family`,
      children: <Family />,
    },
    {
      key: "6",
      label: `Vehicle`,
      children: <Vehicle />,
    },
  ];

  const onChange2 = (key) => {
    console.log(key);
  };
  const items3 = [];

  const handleSyncWithSingpass = async () => {
    try {
      if (await startNetrustTrial("corppass")) return;
      const response = await fetch(
        `https://www.smart-lend.com/api/singpass/getAuthoriseApi`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      // Read the response as text since it's not JSON
      const url = await response.text();

      if (!response.ok || !url.startsWith("http")) throw new Error("Unable to start Myinfo Business.");
      window.location.href = url;
    } catch { setShowSingpassError(true); }
  };

  const handleSyncWithMyinfo = async () => {
    try {
      if (await startNetrustTrial("myinfo")) return;
      const setTokenCookieForRedirect = () => {
        const token = Cookies.get("token");
        if (!token) return;
        const options = { expires: 7, path: "/" };
        const hostname = window.location.hostname;
        if (hostname.endsWith("smart-lend.com")) {
          options.domain = ".smart-lend.com";
          options.sameSite = "None";
          options.secure = true;
        }
        Cookies.set("token", token, options);
      };

      setTokenCookieForRedirect();
      const response = await fetch(
        `https://www.smart-lend.com/api/generateCodeChallenge`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify({
            type: "borrower",
          }),
        }
      );

      // Read the response as text since it's not JSON
      const json = await response.json();
      console.log(json);
      const url = json.singpass_url;
      Cookies.set("latest_session_id", json.session_id);

      if (url.startsWith("http")) {
        // Simple check to ensure it looks like a URL
        // console.log(url);
        window.location.href = url;
      }
    } catch (err) {
      console.error("Error fetching Singpass URL:", err);
      if (isNetrustTrialEntry()) message.error(err.message || "Unable to start authentication.");
    }
  };

  useEffect(() => {
    // To redirect user if not authenticated
    const isAuthenticated = Cookies.get("token");
    const user_account_type = Cookies.get("user_account_type");
    const currentURL = new URL(window.location.href);
    const state = currentURL.searchParams.get("state");

    if (isCrmSyncState(state)) {
      return;
    }

    if (!isAuthenticated) {
      history.push("/auth/signin");
    } else if (user_account_type === "lender") {
      history.push("/dashboard");
    }
  }, [history]);

  const [screenWidth, setScreenWidth] = useState(1920);
  const [isMobile, setIsMobile] = useState(
    Cookies.get("ismobile") === "yes" ? true : false
  );
  useEffect(() => {
    if (screenWidth < 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getInitials = (name) => {
    const textToSplit = name.split(" ");
    const initials =
      textToSplit?.[0]?.[0].toUpperCase() +
      (textToSplit?.[1]?.[0].toUpperCase() || "");
    return initials;
  };

  const ContainerActivity = ({ title, subtitle }) => (
    <div
      style={{
        width: "100%",
        textAlign: "left",
        marginBottom: "7px",
        border: "none",
        borderRadius: "var(--br-card-radius, 10px)",
        backgroundColor: "var(--br-surface, #FFFFFFB3)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px",
        }}
      >
        <div
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            background: "rgb(140,140,170)",
            marginLeft: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            color: "white",
            fontSize: 20,
            fontWeight: 600,
          }}
        >
          {title ? getInitials(title) : "SL"}
        </div>
        <div style={{ marginLeft: "5px", width: "calc(100% - 70px)" }}>
          <h3
            style={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: 700,
              fontSize: "13px",
              color: "var(--br-text, #435669)",
              margin: "0px",
            }}
          >
            {title}
          </h3>
          <p
            style={{
              fontFamily: "Manrope, sans-serif",
              fontWeight: "600",
              fontSize: "11px",
              color: "rgba(0,0,0,0.4)",
              margin: "0px",
            }}
          >
            {subtitle}
          </p>
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/profile/viewActivityLog",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        // const processedData = await Promise.all(
        //   data.map(async (item) => {
        //     const profilePictureResponse = await fetch(
        //       `https://www.smart-lend.com/api/loan/loanRequest/viewListProfilePicture?profile_picture=${item.profile_picture}`,
        //       options
        //     );

        //     if (!profilePictureResponse.ok) {
        //       throw new Error("Failed to fetch profile picture data");
        //     }

        //     const blob = await profilePictureResponse.blob();
        //     const imageUrl = URL.createObjectURL(blob);

        //     return {
        //       ...item,
        //       icon: imageUrl, // use the blob URL as the icon
        //     };
        //   })
        // );
        const reversedData = data.reverse();

        setActivityLog(reversedData);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/ads/getAdsByScreen?screen=bProfile",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        setDisplayAds(data["ads"]);
        setAdImage(data.ads[0].image);
        setAdLink(data.ads[0].link);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (displayAds.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % displayAds.length);
      }, 3200);

      return () => clearInterval(interval); // Cleanup interval on component unmount
    }
  }, [displayAds]);

  useEffect(() => {
    if (displayAds.length > 0) {
      console.log(currentIndex);
      setAdImage(displayAds[currentIndex].image);
      setAdLink(displayAds[currentIndex].link);
    }
  }, [currentIndex, displayAds]);

  function formatDate(datetimeString) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const date = new Date(datetimeString);
    const year = date.getFullYear();
    const monthIndex = date.getMonth();
    const day = String(date.getDate()).padStart(2, "0");
    const month = months[monthIndex];
    return `${day} ${month} ${year}`;
  }

  const [profileLastUpdate, setProfileLastUpdate] = useState(null);

  const BRAND = "var(--br-primary, rgb(14, 90, 165))";
  const BRAND2 = "rgb(109, 92, 246)";

  const SyncCard = ({
    title,
    subtitle,
    buttonLabel,
    onClick,
    singpassLogo,
  }) => {
    return (
      <div
        style={{
          background: "var(--br-surface, rgba(255,255,255,0.72))",
          border: "1px solid rgba(148,163,184,0.22)",
          borderRadius: "var(--br-card-radius, 18px)",
          boxShadow: "var(--br-shadow, 0 14px 34px rgba(2,8,23,0.08))",
          padding: "16px 16px",
          display: "flex",
          flexDirection: "column",
          gap: 12,
          minHeight: 140,
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
          <div
            style={{
              height: 42,
              width: 42,
              borderRadius: "var(--br-card-radius, 14px)",
              background: "rgba(var(--br-primary-rgb, 14,90,165), 0.08)",
              border: "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: "0 0 auto",
            }}
          >
            <img src={singpassLogo} alt="" style={{ height: 18 }} />
          </div>

          <div style={{ flex: 1 }}>
            <div
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: 900,
                fontSize: 16,
                color: "rgba(15,23,42,0.88)",
                lineHeight: 1.15,
              }}
            >
              {title}
              <span style={{ fontWeight: 800, color: "rgba(15,23,42,0.55)" }}>
                {" "}
                with{" "}
              </span>
              <span style={{ fontWeight: 900, color: "rgba(239,68,68,0.95)" }}>
                Singpass
              </span>
            </div>

            <div
              style={{
                marginTop: 8,
                display: "flex",
                gap: 10,
                alignItems: "flex-start",
                color: "rgba(15,23,42,0.62)",
                fontFamily: "Manrope, sans-serif",
                fontWeight: 700,
                fontSize: 12,
                lineHeight: 1.35,
              }}
            >
              <div
                style={{
                  marginTop: 1,
                  height: 18,
                  width: 18,
                  borderRadius: 999,
                  background: "rgba(var(--br-primary-rgb, 14,90,165), 0.10)",
                  border: "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.16)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: BRAND,
                  fontWeight: 900,
                  fontSize: 12,
                  flex: "0 0 auto",
                }}
              >
                ✓
              </div>
              <div>{subtitle}</div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "auto", paddingTop: approvedPersonalSingpassButton ? 4 : 0 }}>
          {approvedPersonalSingpassButton ? <BusinessSingpassButton onClick={onClick} /> : (
          <div
            onClick={onClick}
            style={{
              width: "fit-content",
              padding: "12px 16px",
              borderRadius: "var(--br-card-radius, 14px)",
              cursor: "pointer",
              userSelect: "none",
              background: `linear-gradient(135deg, ${BRAND} 0%, ${BRAND2} 120%)`,
              color: "white",
              fontFamily: "Manrope, sans-serif",
              fontWeight: 900,
              boxShadow: "var(--br-shadow, 0 12px 26px rgba(var(--br-primary-rgb, 14,90,165), 0.16))",
              border: "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.20)",
            }}
          >
            {buttonLabel} <span style={{ marginLeft: 10 }}>›</span>
          </div>
          )}
        </div>
      </div>
    );
  };

  const SyncCombinedMobile = ({ singpassLogo, onMyinfo, onCorppass }) => {
    return (
      <div
        style={{
          background: "var(--br-surface, rgba(255,255,255,0.72))",
          border: "1px solid rgba(148,163,184,0.22)",
          borderRadius: "var(--br-card-radius, 18px)",
          boxShadow: "var(--br-shadow, 0 14px 34px rgba(2,8,23,0.08))",
          padding: approvedPersonalSingpassButton ? 16 : 14,
          display: "grid",
          gap: approvedPersonalSingpassButton ? 16 : 12,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div
            style={{
              height: 40,
              width: 40,
              borderRadius: "var(--br-card-radius, 14px)",
              background: "rgba(var(--br-primary-rgb, 14,90,165), 0.08)",
              border: "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={singpassLogo} alt="" style={{ height: 30 }} />
          </div>

          <div style={{ flex: 1 }}>
            <div
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: 900,
                fontSize: 16,
                color: "rgba(15,23,42,0.88)",
                lineHeight: 1.2,
              }}
            >
              Sync with Singpass
            </div>
            <div
              style={{
                marginTop: 4,
                fontFamily: "Manrope, sans-serif",
                fontWeight: 700,
                fontSize: 12,
                color: "rgba(15,23,42,0.58)",
                lineHeight: 1.35,
              }}
            >
              Auto-fill and verify your information securely.
            </div>
          </div>
        </div>

        {/* Two buttons row (never cut off) */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 16,
          }}
        >
          {approvedPersonalSingpassButton ? <div>
            <p style={{ margin: "0 0 16px", fontSize: 12 }}>For personal loan applications</p>
            <BusinessSingpassButton onClick={onMyinfo} />
          </div> : <div
            onClick={onMyinfo}
            style={{
              padding: "12px 12px",
              borderRadius: "var(--br-card-radius, 14px)",
              background: `linear-gradient(135deg, ${BRAND} 0%, ${BRAND2} 120%)`,
              border: "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.20)",
              boxShadow: "var(--br-shadow, 0 12px 26px rgba(var(--br-primary-rgb, 14,90,165), 0.14))",
              color: "white",
              fontFamily: "Manrope, sans-serif",
              fontWeight: 900,
              textAlign: "center",
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            Sync Myinfo
            <div style={{fontSize: 10, opacity: 0.8}}>Personal Loan Appl.</div>
          </div>}

          <BusinessEntry onStart={onCorppass} onManual={openBusinessAssistance} />
        </div>
      </div>
    );
  };

  const operations = (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: 12,
        marginTop: "-1vh",
      }}
    >
      {/* Personal loans */}
      <SyncCard
        title="Sync with Myinfo"
        subtitle="For personal loan applications"
        icon={
          <img
            src={singlogo}
            alt=""
            style={{ height: 18, width: "auto", objectFit: "contain" }}
          />
        }
        actionLabel="Sync Myinfo"
        onClick={() => handleSyncWithMyinfo()}
      />

      <BusinessEntry onStart={handleSyncWithSingpass} onManual={openBusinessAssistance} />
    </div>
  );

  const [reminderModal, setReminderModal] = useState(false);

  useEffect(() => {
    const expressAuth = isNetrustTrialCallback() ? null : Cookies.get("expressauth");

    const currentURL = new URL(window.location.href);
    const code = currentURL.searchParams.get("code");
    const state = currentURL.searchParams.get("state");
    if (isCrmSyncState(state)) {
      return;
    }
    if (expressAuth) {
      redirectToUrl("/director-authorization");
    } else if (!code && !state) {
      const fetchSingpassData = async () => {
        try {
          const response = await fetch(
            "https://www.smart-lend.com/api/singpass/getSingpassData",
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + Cookies.get("token"),
                Accept: "application/json",
              },
            }
          );

          if (!response.ok) {
            // Handle HTTP error responses (e.g., 404, 500)
            throw new Error(`HTTP Error: ${response.status}`);
          }

          const json = await response.json();
          console.log(json.last_updated_at);

          // Compare dates
          const lastUpdateDate = new Date(json.last_updated_at);
          const currentDate = new Date();
          const oneMonthAgo = new Date();
          oneMonthAgo.setMonth(currentDate.getMonth() - 1);

          if (lastUpdateDate < oneMonthAgo) {
            setReminderModal(true);
          }

          setProfileLastUpdate(json.last_updated_at);
          setSavedBusinessData(json.singpass_data || null);
        } catch (error) {
          console.error(error);
        }
      };

      const fetchActiveData = async () => {
        try {
          const response = await fetch(
            "https://www.smart-lend.com/api/profile/getUserActive",
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + Cookies.get("token"),
                Accept: "application/json",
              },
            }
          );
          if (!response.ok) {
            throw new Error(`HTTP Error: ${response.status}`);
          }
          const json = await response.json();
          console.log(json.data);
          setActiveData(json.data);
        } catch (error) {
          console.log(error);
        }
      };
      fetchActiveData();
      fetchSingpassData();
    }
  }, []);

  const handleUpdateActiveData = async () => {
    try {
      const formData = new FormData();
      formData.append("active_email", activeData.active_email);
      formData.append("active_mobile_no", activeData.active_mobile_no);

      const response = await fetch(
        "https://www.smart-lend.com/api/profile/updateUserTable",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: formData,
        }
      );

      const json = await response.json();
      console.log(json);

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const profilePictureUrl =
        (await loadprofilepicture()) || Cookies.get("profile_picture");
      if (profilePictureUrl) {
        setImageUrl(profilePictureUrl);
      }
    }
    fetchData();
  }, []);

  const handleUploadProfilePicture = async (file) => {
    console.log("uploading profile picture");
    try {
      const formData = new FormData();
      formData.append("profile_picture", file);
      console.log("uploading", formData);
      const response = await fetch(
        "https://www.smart-lend.com/api/profile/uploadProfilePicture",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: formData,
        }
      );

      const data = await response.json();

      console.log("Profile picture created", data);

      // Update the imageUrl state with the new image URL
      if (data.profile_picture) {
        setImageUrl(data.profile_picture);
        Cookies.set("profile_picture", data.profile_picture);
        message.success("Profile picture updated");
        // notification.open({
        //   message: "Notification Title",
        //   description:
        //     "I will never close automatically. This is a purposely very very long description that has many many characters and words.",
        //   duration: 4,
        // });
      } else if (data.error && data.error.profile_picture) {
        // If the profile picture failed to upload
        throw new Error(data.error.profile_picture[0]);
      }
    } catch (error) {
      console.error("Error Uploading Picture", error);
      setErrorMessage(error.message);
    }
  };

  const [imageUrl, setImageUrl] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleBeforeUpload = (file) => {
    const imageUrl = URL.createObjectURL(file);
    setImageUrl(imageUrl);
    console.log("Photo ready to upload", file);
    setSelectedFile(file);
    return false; // Prevent file from being uploaded automatically
  };

  const handleConfirm = () => {
    if (selectedFile) {
      handleUploadProfilePicture(selectedFile);
      console.log("selectedFile exists", selectedFile);
      setSelectedFile(null); // Reset the selected file after uploading
    }
  };

  const loadprofilepicture = async () => {
    console.log("getting profile picture");
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/profile/viewInfoProfilePicture",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch profile picture");
      }

      const blob = await response.blob();
      const imageUrl = URL.createObjectURL(blob);
      console.log("Profile picture retrieved", imageUrl);
      return imageUrl;
    } catch (error) {
      console.error("Error retrieving profile picture", error);
      return null;
    }
  };

  const callToZoho = async (data) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/creating/handleZohoRequest`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify({ bodyToPass: data }),
        }
      );
      if (response.status === 200) {
        const json = await response.json();
        console.log(json?.data?.data?.[0]?.details?.id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const UI = {
    card: {
      background: "var(--br-surface, rgba(255,255,255,0.72))",
      border: "1px solid rgba(148,163,184,0.22)",
      boxShadow: "var(--br-shadow, 0 14px 34px rgba(2,8,23,0.08))",
      backdropFilter: "blur(10px)",
      borderRadius: "var(--br-card-radius, 18px)",
    },
    cardSoft: {
      background: "var(--br-surface, rgba(255,255,255,0.62))",
      border: "1px solid rgba(148,163,184,0.18)",
      boxShadow: "var(--br-shadow, 0 12px 26px rgba(2,8,23,0.06))",
      backdropFilter: "blur(10px)",
      borderRadius: "var(--br-card-radius, 16px)",
    },
    headerTitle: {
      fontFamily: "Manrope, sans-serif",
      fontWeight: 900,
      fontSize: 18,
      color: "rgba(15,23,42,0.88)",
      letterSpacing: "-0.2px",
    },
    headerAction: {
      borderRadius: 999,
      padding: "8px 16px",
      fontSize: 13,
      fontWeight: 900,
      fontFamily: "Manrope, sans-serif",
      border: "1px solid rgba(148,163,184,0.22)",
      background: "var(--br-surface, rgba(255,255,255,0.72))",
      boxShadow: "var(--br-shadow, 0 12px 26px rgba(2,8,23,0.07))",
      cursor: "pointer",
      color: "rgba(15,23,42,0.82)",
    },
    headerActionHover: {
      background:
        "linear-gradient(135deg, var(--br-primary, rgb(14, 90, 165)) 0%, rgb(109, 92, 246) 120%)",
      color: "#fff",
      border: "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.18)",
      boxShadow: "var(--br-shadow, 0 14px 34px rgba(var(--br-primary-rgb, 14,90,165), 0.18))",
    },
    subLabel: {
      fontFamily: "Manrope, sans-serif",
      fontWeight: 800,
      fontSize: 12,
      color: "rgba(15,23,42,0.50)",
    },
    value: {
      fontFamily: "Manrope, sans-serif",
      fontWeight: 900,
      fontSize: 18,
      color: "rgba(15,23,42,0.88)",
    },
    divider: {
      width: 1,
      height: 44,
      background: "rgba(148,163,184,0.30)",
      borderRadius: 999,
    },
    helpDot: {
      width: 18,
      height: 18,
      borderRadius: 999,
      border: "1px solid rgba(148,163,184,0.55)",
      background: "rgba(241,245,249,0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  };

  return (
    <div>
      <style>{`
        /* --- Tabs: welcome-wizard pill style --- */
        .sl-tabs .ant-tabs-nav { margin: 0 0 14px 0; }
        .profileTopTabs .sl-tabs--sub > .ant-tabs-nav { overflow-y: hidden; }
        .sl-tabs .ant-tabs-nav::before { border-bottom: none !important; }
        .sl-tabs .ant-tabs-nav-wrap { padding: 6px; border-radius: 999px;
          background: rgba(241,245,249,0.70);
          border: 1px solid rgba(148,163,184,0.18);
        }
        .sl-tabs.sl-tabs--sub .ant-tabs-nav-wrap{
          background: rgba(248,250,252,0.72);
          border: 1px solid rgba(148,163,184,0.16);
        }
        .sl-tabs .ant-tabs-nav-list { gap: 6px; }
        .sl-tabs .ant-tabs-tab {
          border-radius: 999px !important;
          padding: 8px 14px !important;
          margin: 0 !important;
          background: transparent !important;
          border: none !important;
          font-family: Manrope, sans-serif;
          font-weight: 900;
          font-size: 13px;
          color: rgba(15,23,42,0.65);
          transition: transform .12s ease, background .12s ease, box-shadow .12s ease;
        }
        .sl-tabs .ant-tabs-tab:hover { transform: translateY(-1px); }
        .sl-tabs .ant-tabs-tab.ant-tabs-tab-active {
          background: linear-gradient(135deg, rgba(var(--br-primary-rgb, 14,90,165), 0.14) 0%, rgba(109,92,246,0.10) 120%) !important;
          box-shadow: 0 12px 26px rgba(2,8,23,0.08);
        }
        .sl-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
          color: rgba(15,23,42,0.88) !important;
        }
        .sl-tabs .ant-tabs-ink-bar { display: none !important; }

        /* Cleaner tab content spacing */
        .sl-tab-panel {
          background: rgba(255,255,255,0.72);
          border: 1px solid rgba(148,163,184,0.18);
          border-radius: 20px;
          box-shadow: 0 18px 46px rgba(2,8,23,0.06);
          padding: 18px;
        }


        /* Form inputs: cleaner wizard feel */
        .sl-tab-panel .ant-form-item { margin-bottom: 14px; }
        .sl-tab-panel .ant-form-item-label > label{
          font-family: Manrope, sans-serif;
          font-weight: 900;
          color: rgba(15,23,42,0.70);
        }
        .sl-tab-panel .ant-input,
        .sl-tab-panel .ant-input-affix-wrapper,
        .sl-tab-panel .ant-picker,
        .sl-tab-panel .ant-select-selector,
        .sl-tab-panel textarea{
          border-radius: 14px !important;
          border: 1px solid rgba(148,163,184,0.22) !important;
          background: rgba(255,255,255,0.78) !important;
          box-shadow: 0 10px 22px rgba(2,8,23,0.04);
        }
        .sl-tab-panel .ant-select-selector { align-items: center; }
        .sl-tab-panel .ant-input:focus,
        .sl-tab-panel .ant-input-affix-wrapper-focused,
        .sl-tab-panel .ant-picker-focused,
        .sl-tab-panel .ant-select-focused .ant-select-selector{
          border-color: rgba(var(--br-primary-rgb, 14,90,165), 0.35) !important;
          box-shadow: 0 0 0 4px rgba(var(--br-primary-rgb, 14,90,165), 0.10) !important;
        }
        .sl-tab-panel .ant-divider{ border-top-color: rgba(148,163,184,0.18) !important; }
        /* Mobile adjustments */
        @media (max-width: 900px) {
          .sl-tabs .ant-tabs-nav-wrap { border-radius: 18px; padding: 6px; }
          .sl-tabs .ant-tabs-tab { font-size: 12px; padding: 8px 12px !important; }
          .sl-tab-panel { padding: 14px; border-radius: 18px; }
        }
      `}</style>

      {isLoading && (
        <div className="loading-overlay">
          <Spin size="large" />
        </div>
      )}

      <Modal
        width="min(560px, calc(100vw - 24px))"
        className="auth-status-modal"
        visible={showSingpassError}
        onCancel={() => {
          setShowSingpassError(false);
        }}
        footer={null}
      >
        <BusinessRetrievalError
          onRetry={() => { setShowSingpassError(false); handleSyncWithSingpass(); }}
          onManual={openBusinessAssistance}
          onCancel={() => setShowSingpassError(false)}
        />
      </Modal>
      <Modal
        width="min(560px, calc(100vw - 24px))"
        className="auth-status-modal"
        visible={showCorporateLoanPrompt}
        onCancel={() => setShowCorporateLoanPrompt(false)}
        footer={null}
      >
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              fontSize: 26,
              fontWeight: 800,
              color: colors.grey[920],
            }}
          >
            You&#39;re all set!
          </div>
          <div style={{ color: "rgba(0,0,0,0.6)", marginTop: "10px" }}>
            Would you like to proceed to apply for a corporate loan, or stay on
            this page?
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 12,
              marginTop: 20,
              flexWrap: "wrap",
            }}
          >
            <Button
              type="primary"
              onClick={() => {
                setShowCorporateLoanPrompt(false);
                history.push("/b-loan-hub");
              }}
              style={{
                background: "linear-gradient(135deg, var(--br-primary, #0e5aa5) 0%, #6d5cf6 120%)",
                border: "none",
                fontWeight: 700,
              }}
            >
              Apply corporate loan
            </Button>
            <Button onClick={() => setShowCorporateLoanPrompt(false)}>
              Stay on this page
            </Button>
          </div>
        </div>
      </Modal>
      <Box m={isMobile ? "4px 0px 20px 0px" : "4px 20px 20px 20px"}>
        <Modal
          width="min(1120px, calc(100vw - 24px))"
          className="auth-confirm-modal"
          open={isModalVisible}
          aria-labelledby="business-confirmation-title"
          onCancel={discardBusinessReview}
          maskClosable={false}
          closable={!isSavingBusiness}
          footer={<div className="mib-confirm-save"><button type="submit" form="business-confirmation-form" disabled={isSavingBusiness}>{isSavingBusiness ? "Saving..." : "Save"}</button></div>}
          destroyOnClose
        >
          <div className="mib-confirm-heading">
            <h2 id="business-confirmation-title">Confirm your information</h2>
            <p>By clicking save, you confirm that the provided information is indeed correct.</p>
          </div>
          <BusinessDataReview data={singpassData} onConfirm={handleSave} busy={isSavingBusiness} confirmation formId="business-confirmation-form" />
        </Modal>
        <Box
          display={isMobile ? "flex" : "grid"}
          flexDirection={isMobile ? "column" : undefined}
          gridTemplateColumns={isMobile ? undefined : "repeat(12, minmax(0, 1fr))"}
          gridAutoRows={isMobile ? undefined : "auto"}
          alignItems="start"
          gap="20px"
        >
          <Box
            sx={{
              ...(isMobile
                ? { width: "100%" }
                : { gridColumn: "span 9", gridRow: "span 2" }),
              ...UI.card,
              minWidth: 0,
              overflow: "visible",
              height: "auto",
              p: isMobile ? "8px 10px 120px" : "12px 16px 140px",
              background: "var(--br-surface, rgba(255,255,255,0.35))",
              borderRadius: "var(--br-card-radius, 22px)",
            }}
          >
            <Box
              gridColumn="span 4"
              gridRow="span 2"
              background="var(--br-card-surface, transparent linear-gradient(180deg, #FFFFFFB3 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box)"
              border-radius="20px"
              opacity="0.95"
            >
              <Card>
                {/* TOP: Personal / Business / Verification + Sync area */}
                <div style={{ display: isMobile ? "" : "grid", gridTemplateColumns: "minmax(0, 1fr)", minWidth: 0, gap: 14 }}>
                  {isMobile ? (
                    <SyncCombinedMobile
                      singpassLogo={singlogo}
                      onMyinfo={handleSyncWithMyinfo}
                      onCorppass={handleSyncWithSingpass}
                    />
                  ) : (
                    <div className="profile-sync-cards"
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                        gap: 14,
                        alignItems: "stretch",
                      }}
                    >
                      <SyncCard
                        singpassLogo={singlogo}
                        title="Sync MyInfo"
                        subtitle="Auto-fill personal fields via Singpass for Personal Loans."
                        buttonLabel="Sync Myinfo"
                        onClick={handleSyncWithMyinfo}
                      />
                      <BusinessEntry onStart={handleSyncWithSingpass} onManual={openBusinessAssistance} />
                    </div>
                  )}
                  {/* MAIN TOP TABS (always full width, never share row with sync UI) */}
                  <Tabs
                    className="profileTopTabs"
                    style={{ minWidth: 0 }}
                    activeKey={activeMainTab}
                    onChange={setActiveMainTab}
                  >
                    <TabPane type="card" tab="Personal" key="1">
                      <Tabs
                        className="sl-tabs sl-tabs--sub"
                        defaultActiveKey="1"
                        items={items}
                        onChange={onChange}
                        size={isMobile ? "small" : "middle"}
                        tabBarGutter={isMobile ? 8 : 16}
                      />
                    </TabPane>
                    <TabPane type="card" tab="Business" key="2">
                      <Tabs
                        className="sl-tabs sl-tabs--sub"
                        defaultActiveKey="profile"
                        size={isMobile ? "small" : "middle"}
                        tabBarGutter={isMobile ? 8 : 16}
                        items={businessSections(savedBusinessData).map(([key, title]) => ({ key, label: title, children: <BusinessDataReview data={savedBusinessData} onlySection={key} /> }))}
                      />
                    </TabPane>
                    <TabPane
                      type="card"
                      key="3"
                      tab={
                        <div
                          className={
                            verifiedStatus ? "" : "custom-tab-class blinking"
                          }
                        >
                          Verification
                        </div>
                      }
                    >
                      <div
                        className="sl-tab-panel"
                        style={{
                          fontFamily: "Manrope",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            marginBottom: "-5px",
                            marginTop: "5px",
                            display: "flex",
                            width: "100%",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            fontSize: "12px",
                            fontWeight: 800,
                            marginTop: "0px",
                          }}
                        >
                          Verification Status:{" "}
                          {verifiedStatus ? (
                            <CheckCircleIcon
                              style={{ fontSize: "20px", color: "green" }}
                            />
                          ) : (
                            <CancelIcon
                              style={{ fontSize: "20px", color: "red" }}
                            />
                          )}
                        </div>
                        <div
                          style={{
                            fontSize: "18px",
                            fontWeight: 800,
                            marginTop: "0px",
                          }}
                        >
                          Get your account verified
                        </div>
                        <div style={{ fontSize: "11px", fontWeight: 400 }}>
                          Getting your account verified would increase the
                          credibility of your account to other lenders and also
                          provide you with a higher chance of receiving more
                          offers from lenders as lenders would be able to see
                          that your business operations have been verified by
                          SmartLend.
                        </div>
                        <div
                          style={{
                            fontSize: "18px",
                            fontWeight: 800,
                            marginTop: "15px",
                          }}
                        >
                          How to get verified?
                        </div>
                        <div style={{ fontSize: "12px", fontWeight: 400 }}>
                          You can start by uploading the below documents to
                          allow our admins to verify your business opertations
                        </div>
                        <div
                          style={{
                            fontSize: "10px",
                            fontWeight: 400,
                            marginTop: "10px",
                          }}
                        >
                          - An image of your storefront.
                        </div>
                        <div style={{ fontSize: "10px", fontWeight: 400 }}>
                          - Receipt or bills to confirm your business operation
                          address/location.
                        </div>
                        <div style={{ fontSize: "10px", fontWeight: 400 }}>
                          - Tenancy agreement of your business operation.
                        </div>
                        <div style={{ marginTop: "15px" }}>
                          {uploadedFiles && uploadedFiles.length > 0 ? (
                            <div
                              style={{
                                fontSize: "11px",
                                fontWeight: 500,
                                width: "calc(100% - 30px)",
                                background: "rgba(153, 178, 205, 0.4)",
                                padding: "15px 15px 10px 15px",
                                borderRadius: "var(--br-card-radius, 8px)",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "18px",
                                  fontWeight: 800,
                                  marginBottom: "5px",
                                }}
                              >
                                Verification Files
                              </div>
                              {uploadedFiles.map((file, index) => (
                                <div
                                  key={index}
                                  style={{
                                    marginBottom: "5px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "25px",
                                  }}
                                >
                                  <div
                                    style={{
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => {
                                      const newWindow = window.open(
                                        file.url,
                                        "_blank",
                                        "noopener,noreferrer"
                                      );
                                      if (newWindow) newWindow.opener = null;
                                    }}
                                  >
                                    {file.name}
                                  </div>
                                  <DeleteIcon
                                    style={{
                                      fontSize: "20px",
                                      color: "grey",
                                      cursor: "pointer",
                                      marginTop: "2px",
                                    }}
                                    onClick={() => {
                                      const updatingUploadedFiles = [
                                        ...uploadedFiles,
                                      ];
                                      updatingUploadedFiles.splice(index, 1);
                                      setUploadedFiles(updatingUploadedFiles);
                                      updateUserVerificationFiles(
                                        updatingUploadedFiles
                                      );
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          ) : null}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <input
                              style={{ marginTop: "15px" }}
                              type="file"
                              multiple
                              onChange={(e) => {
                                e.preventDefault();
                                onFileSelected(e.target.files);
                                console.log(e.target.files);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </TabPane>
                  </Tabs>

                  {/* SYNC AREA */}
                </div>
              </Card>
            </Box>
          </Box>
          {!isMobile ? (
            <Box
              gridColumn="span 3"
              gridRow="span 2"
              // backgroundColor="rgba(153, 178, 205, 0)"
              overflow="auto"
              minHeight="90.5vh"
            >
              <Box
                gridColumn="span 2"
                opacity="1.00"
                display="flex"
                alignItems="center"
                justifyContent="center"
                position="relative"
              >
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    paddingTop: "100%", // This makes height equal to width (1:1 ratio)
                    borderRadius: "10px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={adImage}
                    onClick={(e) => {
                      e.preventDefault();
                      if (adLink) {
                        let url = adLink;

                        // Check if adLink starts with http:// or https://
                        if (!/^https?:\/\//i.test(adLink)) {
                          url = `https://${adLink}`;
                        }

                        console.log(url);
                        window.open(url, "_blank");
                      }
                    }}
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "10px",
                      cursor: adLink ? "pointer" : "default",
                    }}
                  />
                </div>
              </Box>
              <Box
                gridColumn="span 4"
                gridRow="span 2"
                backgroundColor="rgba(153, 178, 205, 0)"
                overflow="auto"
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  // borderBottom={`4px solid ${colors.primary[500]}`}
                  colors={colors.grey[100]}
                  p="10px"
                >
                  <Typography
                    color={colors.grey[920]}
                    variant="h5"
                    fontWeight="800"
                    fontFamily="Manrope, sans-serif"
                    fontSize="18px"
                  >
                    Recent Activities
                  </Typography>
                </Box>
                {dataActivityLog && dataActivityLog.length > 0 ? (
                  dataActivityLog.slice(0, 6).map((item, index) => (
                    <div
                      style={{
                        opacity:
                          index === 4
                            ? 0.6
                            : index === 5
                            ? 0.2
                            : index === 3
                            ? 0.9
                            : 1,
                        transitionDelay: `${index * 0.1}s`,
                      }}
                    >
                      <ContainerActivity
                        key={index}
                        title={item.principal_name || "-"}
                        subtitle={item.description || "-"}
                        index={index}
                      />
                    </div>
                  ))
                ) : (
                  <div
                    style={{
                      width: "100%",
                      padding: "0px 0px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        padding: "0px 15px",
                        background: "var(--br-surface, rgba(255,255,255,0.7))",
                        borderRadius: "var(--br-card-radius, 10px)",
                        height: "350px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontFamily: "Manrope, sans-serif",
                        fontSize: "0.8em",
                        fontWeight: "600",
                        color: "#00000066",
                      }}
                    >
                      No recent activities
                    </div>
                  </div>
                )}
              </Box>
            </Box>
          ) : null}
        </Box>
      </Box>

      {/* <Modal
        width={window.innerWidth < 1200 ? "80%" : "30%"}
        visible={reminderModal}
        onCancel={() => setReminderModal(false)}
        footer={null}
        style={{ top: "50%", transform: "translate(0, -50%)" }}
      >
        <div style={{ fontWeight: 700, fontSize: 24, color: "rgb(60,60,60)" }}>
          Singpass Resync Required
        </div>
        <div style={{ fontWeight: 300, fontSize: 12, color: "grey" }}>
          Please take note that to ensure you can proceed to further apply any
          more new loans, your singpass synchronisation cannot be more then 1
          month ago, if you would like to proceed to resync your singpass
          account, click on the button below.
        </div>

        <button
          onClick={(event) => {
            event.preventDefault();
            handleSyncWithSingpass(event);
          }}
          style={{
            border: "1px solid rgb(190,190,190)",
            borderRadius: "6px",
            padding: "8px 20px",
            display: "flex",
            alignItems: "center",
            gap: 5,
            cursor: "pointer",
            margin: "20px 0px 0px 0px",
          }}
        >
          Sync With
          <img
            src={singlogo}
            style={{
              objectFit: "cover",
              width: "100px",
              height: "20px",
              cursor: "pointer",
            }}
          />
        </button>
      </Modal> */}

      <Modal
        width="min(560px, calc(100vw - 24px))"
        className="auth-status-modal"
        visible={notSameEntityModalIsOpen}
        onCancel={() => setNotSameEntityModalIsOpen(false)}
        footer={null}
        style={{ top: "50%", transform: "translate(0, -50%)" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
          }}
        >
          <div>
            <ErrorIcon style={{ color: "red", fontSize: "60px" }} />
          </div>
          <div>
            <div
              style={{ fontWeight: 700, fontSize: 24, color: "rgb(60,60,60)" }}
            >
              Entity Name Missmatch
            </div>
            <div style={{ fontWeight: 300, fontSize: 12, color: "grey" }}>
              You've tried to synchronise with a singpass account that doesnt
              match the entity name of the original synchronisation.
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        width="min(560px, calc(100vw - 24px))"
        className="auth-status-modal"
        visible={sameAsOtherEntityModalIsOpen}
        onCancel={() => setSameAsOtherEntityModalIsOpen(false)}
        footer={null}
        style={{ top: "50%", transform: "translate(0, -50%)" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
          }}
        >
          <div>
            <ErrorIcon style={{ color: "red", fontSize: "60px" }} />
          </div>
          <div>
            <div
              style={{ fontWeight: 700, fontSize: 24, color: "rgb(60,60,60)" }}
            >
              Entity Name Registered
            </div>
            <div style={{ fontWeight: 300, fontSize: 12, color: "grey" }}>
              The Corppass Entity Name you synchronised with has been used by
              another account, please note that every entity is only allowed one
              account registration.
            </div>
          </div>
        </div>
      </Modal>

    </div>
  );
};

export default ProfileStaging;
